import firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/database';
import _ from 'lodash'
import format from 'date-fns/format'
import addDays from 'date-fns/add_days';
import subHours  from 'date-fns/sub_hours';
import addHours  from 'date-fns/add_hours';
import addMonths from 'date-fns/add_months';
import subMonths from 'date-fns/sub_months';
import startOfWeek from 'date-fns/start_of_week';
import {globalfunc} from '../globalfunc.js';
import { resolve } from 'path';
import axios from 'axios'
import { connected, cpuUsage } from 'process';
import { subWeeks } from 'date-fns';
import { type } from 'os';
const apiUrl = 'https://api-node.happily.ai'
var jwt = require('jsonwebtoken');
export default {
    namespaced: true,
    state: {
        questions_name: [],
        datachart: [],
        databarchart: {},
        databarchartEngagementScore: {},
        datakeygroup: [],
        activeuser: [],
        happiness: [],
        feedback: [],
        weekofyear: '',
        weekprevious: '',
        weekprevious2: '',
        dateshow: '',
        questions: [
            {
                quest_id: '-Kgs61AHOnpJ3rfyQr6t',
                category_id: '-KxQjHv0aMgv6TWNWemH',
                name: 'Happiness',
                // quest_name: 'How do you feel today at the office?',
                status: {
                    green: 0,
                    yellow: 0,
                    red: 0,
                },
                success: 0,
                compare: 0,
                dimpic: 'Happiness@2x',
            },
            {
                quest_id: '-Kgn7oxLPPWlbM_ZDc_h',
                category_id: '-KxRdFigA6geGzv2zJHQ',
                name: 'Personal Growth',
                // quest_name: 'How would you rate your opportunities for growth?',
                status: {
                    green: 0,
                    yellow: 0,
                    red: 0,
                },
                success: 0,
                compare: 0,
                dimpic: 'Personal-Growth@2x',
            },
            {
                quest_id: '-L0J5FFsGQYVkfcGujWo',
                category_id: '-KxRwgLlN0DpB0p7al7N',
                name: 'Recognition',
                // quest_name: 'Have you gotten any recognition in the last 7 days?',
                status: {
                    green: 0,
                    yellow: 0,
                    red: 0,
                },
                success: 0,
                compare: 0,
                dimpic: 'Recognition@2x',
            },
            {
                quest_id: '-Kgs549ClADmNQwoNbbG',
                category_id: '-KxRyiIXeDebHreB12mM',
                name: 'Relationship with Colleagues',
                // quest_name: 'How would you rate the level of respect colleagues give to each other in your workplace?',
                status: {
                    green: 0,
                    yellow: 0,
                    red: 0,
                },
                success: 0,
                compare: 0,
                dimpic: 'Rel.Colleagues@2x',
            },
            {
                quest_id: '-L1FmpFO-v8IZc_B5EB7',
                category_id: '-KxRzHeGK7cuwKtAKQwF',
                name: 'Satisfaction',
                // quest_name: 'Do you feel challenged at work?',
                status: {
                    green: 0,
                    yellow: 0,
                    red: 0,
                },
                success: 0,
                compare: 0,
                dimpic: 'Satisfaction@2x',
            },
            {
                quest_id: '-L2ycGiBDo3rDGjLNKwW',
                category_id: '-KxRzbMWTgeqpsSbCo_6',
                name: 'Ambassadorship',
                // quest_name: 'Do you see yourself working here one year from now?',
                status: {
                    green: 0,
                    yellow: 0,
                    red: 0,
                },
                success: 0,
                compare: 0,
                dimpic: 'Ambassadorship@2x',
            },
            {
                quest_id: '-L1QWPtZvax_KlJgpNxF',
                category_id: '-KxS-JNn6sNeqTD0KE53',
                name: 'Feedback',
                // quest_name: 'Do you think you get enough feedback?',
                status: {
                    green: 0,
                    yellow: 0,
                    red: 0,
                },
                success: 0,
                compare: 0,
                dimpic: 'Feedback@2x',
            },
            {
                quest_id: '-L1Qug-PhtzVOR2Dr5q7',
                category_id: '-KxS-e4O2--BrGiRWbEF',
                name: 'Relationship with Managers',
                // quest_name: 'In the past 7 days, have you interacted with your manager?',
                status: {
                    green: 0,
                    yellow: 0,
                    red: 0,
                },
                success: 0,
                compare: 0,
                dimpic: 'Rel.Manager@2x',
            },
            {
                quest_id: '-L36rxTgLhZTL4mq4SV1',
                category_id: '-KxS05m9KaS70Ai6ps93',
                name: 'Wellness',
                // quest_name: 'In the past 7 days, have you felt stressed or overwhelmed at work?',
                status: {
                    green: 0,
                    yellow: 0,
                    red: 0,
                },
                success: 0,
                compare: 0,
                dimpic: 'Wellness@2x',
            },
            {
                quest_id: '-LtOL_iR1N-ev2b_8Tmg',
                category_id: '-KxS15s4DhoKSrjs4D7k',
                name: 'Company Alignment',
                // quest_name: 'In the past 7 days, have you felt stressed or overwhelmed at work?',
                status: {
                    green: "-",
                    yellow: "-",
                    red: "-",
                },
                success: "-",
                compare: "-",
                dimpic: 'Company-Alignment@2x',
            }
        ],
        talking_points_daily: [],
        talking_points_monthly: [],
        talking_points_30d: [],
        opt_month_name: [],
        global_variable: {},
        newLabels: [],
        toneAnalyse:[],
        toneLoadingStatus: false,
        databarchartLoadingStatus: false,
        datakeygroupLoadingStatus: false,
        EngagementScoreLoadingStatus: false,
        maximumUsers:0,
        past12Hour:[],
        activeRecord:[],
        _temp:[],
        time:[],
        questionOpenEnd:{},
        engagementpeople:[],
        enps:{},
        adoption:{},
        _tempAdoption:[],
        countAdoption:0,
        totalUsers:0,
        monthlyActiveUser:{},
        weeklyActiveUser:{},
        enpsLoading:true,
        happinessLoading:true,
        impactRatingLoading:true,
        feedbackLoading:true,
        activityLoadingStatus:true,
        openModalDashboard:false,
        benchmarkBreak:'',
        memberAndTeam:[],
        teamHight:'',
        totol_boss:0,
        managerData:{},
        insightsOpenRateSetting: {
            active: 0,
            passive: 0
        },
        feedbackReplyRateSetting: {
            active: 40,
            passive: 10
        },
        teamOneLevel:[],
        teamHeight: '',
    },
    mutations: {
        setChartSuccessScore(state: any, result: any) {
            state.datachart = result
        },
        setChartJobTenure(state: any, result: any) {
            state.databarchart = result
        },
        setChartEngagementScore(state: any, result: any) {
            state.databarchartEngagementScore = result
        },
        setDataKeyGroup(state: any, result: any) {
            state.datakeygroup = result
        },
        setDimension(state: any, result: any) {
            state.dimension = result
        },
        setWeekOfYear(state: any, result: string) {
            state.weekofyear = result
        },
        setWeekPrevious(state: any, result: string) {
            state.weekprevious = result
        },
        setWeekPrevious2(state: any, result: string) {
            state.weekprevious2 = result
        },
        setActiveUser(state: any, result: any) {
            state.activeuser = result
        },
        setHappiness(state: any, result: any) {
            state.happiness = result
        },
        setFeedBack(state: any, result: any) {
            state.feedback = result
        },
        setDateShow(state: any, result: string) {
            state.dateshow = result
        },
        setQuestionsName(state: any, result: any) {
            state.questions_name[result.id] = result.value
        },
        setTalkingPointsDaily(state: any, result: any) {
            state.talking_points_daily = result
        },
        setTalkingPointsMonthly(state: any, result: any) {
            state.talking_points_monthly = result
        },
        setTalkingPoints30D(state: any, result: any) {
            state.talking_points_30d = result
        },
        setOptMonthName(state: any, result: any) {
            state.opt_month_name = result
        },
        setGlobalVariable(state: any, result: any) {
            state.global_variable = result
        },
        setNewLabel(state: any, result: any) {
            state.newLabels = result
        },
        setToneAnalyse(state: any, result: any) {
            state.toneAnalyse = result
        },
        setToneLoadingStatus(state: any, value: any) {
            state.toneLoadingStatus = value
        },
        setDatabarchartLoadingStatus(state: any, value: any) {
            state.databarchartLoadingStatus = value
        },
        setEngagementScoreLoadingStatus(state: any, value: any) {
            state.EngagementScoreLoadingStatus = value
        },
        setDatakeygroupLoadingStatus(state: any, value: any) {
            state.datakeygroupLoadingStatus = value
        },
        setMaximumUsers(state: any, value: any) {
            //console.log("maximumUsers",value)
            state.maximumUsers = value
        },
        setpast12Hour(state: any, value: any) {
            // console.log("past12Hour",value)
            state.past12Hour = value
        },
        setactiveRecord(state: any, value: any) {
            // console.log("activeRecord",value)
            state.activeRecord = value
        },
        setQuestionOpenEnd(state: any, value: any) {
            state.questionOpenEnd = value
        },
        setEngagementpeople(state: any, value: any) {
            state.engagementpeople = value
        },
        setEnps(state: any, value: any) {
            state.enps = value
        },
        setEnpsloading(state: any, value: any) {
            state.enpsLoading = value
        },
        setAdoption(state: any, value: any) {
            state.adoption = value
        },
        setMonthly(state: any, value: any) {
            state.monthlyActiveUser = value
        },
        setWeekly(state: any, value: any) {
            state.weeklyActiveUser = value
        },
        setHappinessloading(state: any, value: any) {
            state.happinessLoading = value
        },
        setImpactRatingloading(state: any, value: any) {
            state.impactRatingLoading = value
        },
        setFeedbackloading(state: any, value: any) {
            state.feedbackLoading = value
        },
        setActivityLoadingStatus(state: any, value: any) {
            state.activityLoadingStatus = value
        },
        setOpenModalDashboard(state: any, value: any) {
            state.openModalDashboard = value
        },
        setBenchmarkBreak(state: any, value: any) {
            state.benchmarkBreak = value
        },
        setMemberAndTeam(state: any, value: any) {
            state.memberAndTeam = value
        },
        setManagerData(state: any, value: any) {
            state.managerData = value
        },
        setTeamHeight(state: any, value: any) {
            state.teamHeight = value
        },
    },
    actions: {
        resetState({ commit }: any) {
            commit('setTalkingPoints30D', [])
            commit('setChartSuccessScore', [])
        },
        getGlobalVariable({ commit, state }: any, global: any) {
            commit('setGlobalVariable', global)
        },
        setWeekOfYear({ commit }: any) {
            const dateNow = new Date()
            //const weekofyear = moment().tz("Asia/Bangkok").startOf('isoWeek').format('YYYY-w')
            const weekofyear = format(startOfWeek(dateNow,{weekStartsOn:1}), 'GGGG-W')
            //const weekprevious = moment().add(-7, 'days').tz("Asia/Bangkok").startOf('isoWeek').format('YYYY-w')
            const weekprevious = format(startOfWeek(addDays(dateNow, -7),{weekStartsOn:1}), 'GGGG-W')
            //const weekprevious2 = moment().add(-14, 'days').tz("Asia/Bangkok").startOf('isoWeek').format('YYYY-w')
            const weekprevious2 = format(startOfWeek(addDays(dateNow, -14),{weekStartsOn:1}), 'GGGG-W')
            
            //const today = moment().tz("Asia/Bangkok").format('d')
            const today:any = format(dateNow, 'd')
            let startdate = ''
            let enddate = ''
            if (today > 1) {
                const date = today - 1
                //startdate = moment().add(-(date * 1), 'days').tz("Asia/Bangkok").format('MMM D')
                startdate = format(addDays(dateNow, -(date*1)), 'MMM D')
            } else if (today == 0) {
                //startdate = moment().add(-6, 'days').tz("Asia/Bangkok").format('MMM D')
                startdate = format(addDays(dateNow, -6), 'MMM D')
            } else {
                //startdate = moment().tz("Asia/Bangkok").format('MMM D')
                startdate = format(dateNow, 'MMM D')
            }
            if (today == 0) {
                //enddate = moment().add(-2, 'days').tz("Asia/Bangkok").format('MMM D')
                enddate = format(addDays(dateNow, -2), 'MMM D')
            } else
                if (today < 5) {
                    const date = 5 - today
                    //enddate = moment().add(+(date * 1), 'days').tz("Asia/Bangkok").format('MMM D')
                    enddate = format(addDays(dateNow, +(date*1)), 'MMM D')
                } else if (today == 6) {
                    //enddate = moment().add(-1, 'days').tz("Asia/Bangkok").format('MMM D')
                    enddate = format(addDays(dateNow, -1), 'MMM D')
                } else {
                    //enddate = moment().tz("Asia/Bangkok").format('MMM D')
                    enddate = format(dateNow, 'MMM D')
                }
            commit('setWeekOfYear', weekofyear)
            commit('setWeekPrevious', weekprevious)
            commit('setWeekPrevious2', weekprevious2)
            commit('setDateShow', `${startdate} - ${enddate}`)
        },
        getActivityThisWeek({ commit, state }: any, user: any) {
            const activity:any = []
            firebase.firestore().collection('weeky_activate_users').doc(`${user.company}-${state.weekofyear}`).get()
                .then(function (doc) {
                    activity[state.weekofyear] = doc.data()

                    firebase.firestore().collection('weeky_activate_users').doc(`${user.company}-${state.weekprevious}`).get()
                    .then(function (doc) {
                        activity[state.weekprevious] = doc.data()
                        if (activity[state.weekprevious] && activity[state.weekofyear]) {
                            if ((activity[state.weekprevious].users * 1) > (activity[state.weekofyear].users * 1)) {
                                const value = Math.ceil((activity[state.weekofyear].users * 100) / activity[state.weekprevious].users);
                                activity[state.weekofyear].calculate = -(100 - value)
                            } else if ((activity[state.weekofyear].users * 1) > (activity[state.weekprevious].users * 1)) {
                                const value = Math.ceil((activity[state.weekprevious].users * 100) / activity[state.weekofyear].users);
                                activity[state.weekofyear].calculate = (100 - value)
                            } else {
                                activity[state.weekofyear].calculate = 0
                            }
                        } else {
                            if (activity[state.weekofyear] === undefined) {
                                activity[state.weekofyear] = {};
                            }
                            activity[state.weekofyear].calculate = 0
                        }
                        commit('setActiveUser', activity[state.weekofyear])
                    });
                });
        },
        getHappinessThisWeek({ commit, dispatch, state }: any, user: any) {
            commit('setHappinessloading',true)
            const happy: { [key: string]: firebase.firestore.DocumentData; } = {};
            firebase.firestore().collection('weeky_insight_happiness_and_risk').where("weekofyear", "==", state.weekofyear).where("company", "==", user.company).get()
                .then(function (querySnapshot) {
                    querySnapshot.forEach(function (doc) {
                        happy[state.weekofyear] = doc.data()
                    });
                    firebase.firestore().collection('weeky_insight_happiness_and_risk').where("weekofyear", "==", state.weekprevious).where("company", "==", user.company).get()
                    .then(function (querySnapshot) {
                        querySnapshot.forEach(function (doc) {
                            happy[state.weekprevious] = doc.data()
                        });
                        if (happy[state.weekprevious] && happy[state.weekofyear]) {
                            const cal1 = Math.ceil((happy[state.weekofyear].happy * 100) / happy[state.weekofyear].total)
                            const cal2 = Math.ceil((happy[state.weekprevious].happy * 100) / happy[state.weekprevious].total)
                            if ((cal2 * 1) > (cal1 * 1)) {
                                happy[state.weekofyear].calculatehappy = -(cal2 - cal1)
                            } else if (cal1 > cal2) {
                                const value = Math.ceil((happy[state.weekprevious].happy * 100) / happy[state.weekofyear].happy)
                                happy[state.weekofyear].calculatehappy = cal1 - cal2
                            } else {
                                happy[state.weekofyear].calculatehappy = 0
                            }
            
                            const cal11 = Math.ceil((happy[state.weekofyear].worse * 100) / happy[state.weekofyear].total)
                            const cal22 = Math.ceil((happy[state.weekprevious].worse * 100) / happy[state.weekprevious].total)
                            if ((cal22 * 1) > (cal11 * 1)) {
                                happy[state.weekofyear].calculaterisk = -(cal22 - cal11)
                            } else if ((cal11 * 1) > (cal22 * 1)) {
                                happy[state.weekofyear].calculaterisk = cal11 - cal22
                            } else {
                                happy[state.weekofyear].calculaterisk = 0
                            }
                        } else {
                            if (happy[state.weekofyear] === undefined) {
                                happy[state.weekofyear] = {};
                            }
                            happy[state.weekofyear].calculatehappy = 0
                            happy[state.weekofyear].calculaterisk = 0
                        }
                        happy[state.weekofyear].calculatehappy = isNaN(happy[state.weekofyear].calculatehappy)?"-":happy[state.weekofyear].calculatehappy
                        happy[state.weekofyear].calculaterisk = isNaN(happy[state.weekofyear].calculaterisk)?"-":happy[state.weekofyear].calculaterisk
                        happy[state.weekofyear].happy = isNaN(Math.ceil((happy[state.weekofyear].happy * 100) / happy[state.weekofyear].total))?"-":Math.ceil((happy[state.weekofyear].happy * 100) / happy[state.weekofyear].total)
                        happy[state.weekofyear].worse = isNaN(Math.ceil((happy[state.weekofyear].worse * 100) / happy[state.weekofyear].total))?"-":Math.ceil((happy[state.weekofyear].worse * 100) / happy[state.weekofyear].total)
                        commit('setHappiness', happy[state.weekofyear])
                        commit('setHappinessloading',false)
                    });
                });
        },
        getFeedbackThisWeek({ commit, dispatch, state }: any, user: any) {
            commit('setFeedbackloading', true)
            const feedback: { [key: string]: firebase.firestore.DocumentData; } = {};
            firebase.firestore().collection('weeky_insight_feedback').where("weekofyear", "==", state.weekofyear).where("company", "==", user.company).get()
                .then(function (querySnapshot) {
                    querySnapshot.forEach(function (doc) {
                        feedback[state.weekofyear] = doc.data()
                    });
                    firebase.firestore().collection('weeky_insight_feedback').where("weekofyear", "==", state.weekprevious).where("company", "==", user.company).get()
                    .then(function (querySnapshot) {
                        querySnapshot.forEach(function (doc) {
                            feedback[state.weekprevious] = doc.data()
                        });
                        if (feedback[state.weekprevious] && feedback[state.weekofyear]) {
                            const cal1 = Math.ceil((feedback[state.weekofyear].feedback * 100) / feedback[state.weekofyear].total)
                            const cal2 = Math.ceil((feedback[state.weekprevious].feedback * 100) / feedback[state.weekprevious].total)
                            if ((cal2 * 1) > (cal1 * 1)) {
                                feedback[state.weekofyear].calculate = -(cal2 - cal1)
                            } else if ((cal1 * 1) > (cal2 * 1)) {
                                feedback[state.weekofyear].calculate = (cal1 - cal2)
                            } else {
                                feedback[state.weekofyear].calculate = 0
                            }
                        } else {
                            if (feedback[state.weekofyear] == undefined) {
                                feedback[state.weekofyear] = {}
                            }
                            feedback[state.weekofyear].calculate = 0
                        }
                        feedback[state.weekofyear].calculate=isNaN(feedback[state.weekofyear].calculate)?"-":feedback[state.weekofyear].calculate
                        feedback[state.weekofyear].feedback = isNaN(Math.ceil((feedback[state.weekofyear].feedback * 100) / feedback[state.weekofyear].total))?"-":Math.ceil((feedback[state.weekofyear].feedback * 100) / feedback[state.weekofyear].total)
                        commit('setFeedBack', feedback[state.weekofyear])
                        commit('setFeedbackloading', false)
                    });
                });
        },
        getQuestionsName({ state,commit }: any){
            const { questions } = state
            _.forEach(questions, async (value, index) => {
                const question = (await firebase.database().ref(`/questions/${questions[index].quest_id}`).once('value')).val();
                //questions[index].quest_name = (question_name[index]!=undefined)?question_name[index]:''
                questions[index].repeats = question.repeats
                if(question.repeats == 'weekly'){
                    questions[index].repeat_days = question.repeat_days
                    questions[index].repeat_every = question.repeat_every
                }
                commit('setQuestionsName',{id:questions[index].quest_id,value:question.question_en});
            });
        },
        getQuestionDataPrevious(){

        },
        getQuestionData({ state }: any, user: any) {
            const dateNow = new Date()
            let weekprevious = format(startOfWeek(addDays(dateNow, -7),{weekStartsOn:1}), 'GGGG-W')
            //const weekprevious2 = moment().add(-14, 'days').tz("Asia/Bangkok").startOf('isoWeek').format('YYYY-w')
            let weekprevious2 = format(startOfWeek(addDays(dateNow, -14),{weekStartsOn:1}), 'GGGG-W')
            // const check1:any[] = weekprevious.split('-')
            // if(check1[1] == '01'){
            //     weekprevious = (check1[0]*1)+1+'-01'
            // }
            // const check2:any[] = weekprevious2.split('-')
            // if(check2[1] == '01'){
            //     weekprevious2 = (check2[0]*1)+1+'-01'
            // }
            let monthofyear1: Array<any> = [];
            var promise4 = new Promise(function(resolve, reject) {
                const data4: { [key: string]: firebase.firestore.DocumentData; } = {}
                firebase.firestore().collection('insight_engagement_monthofyear').where("company", "==", user.company).where("date", ">=", format(addDays(new Date(), -60), 'YYYY-MM-DD')).where("date", "<", format(addDays(new Date(), -30), 'YYYY-MM-DD')).orderBy('date', 'desc').get()
                .then(function (querySnapshot) {
                    querySnapshot.forEach(function (doc) {
                        if(monthofyear1[doc.data().quest_id] == undefined){
                            monthofyear1[doc.data().quest_id] = doc.data()
                            data4[doc.data().quest_id] = doc.data()
                        }
                        
                    });
                    resolve(data4);
                });
            });
            let monthofyear2: Array<any> = [];
            var promise3 = new Promise(function(resolve, reject) {
                const data3: { [key: string]: firebase.firestore.DocumentData; } = {}
                firebase.firestore().collection('insight_engagement_monthofyear').where("company", "==", user.company).where("date", ">=", format(addDays(new Date(), -30), 'YYYY-MM-DD')).where("date", "<", format(new Date(), 'YYYY-MM-DD')).orderBy('date', 'desc').get()
                .then(function (querySnapshot) {
                    querySnapshot.forEach(function (doc) {
                        if(monthofyear2[doc.data().quest_id] == undefined){
                            monthofyear2[doc.data().quest_id] = doc.data()
                            data3[doc.data().quest_id] = doc.data()
                        }
                    });
                    resolve(data3);
                });
            });
            var promise2 = new Promise(function(resolve, reject) {
                const data2: { [key: string]: firebase.firestore.DocumentData; } = {}
                firebase.firestore().collection('insight_engagement_weekofyear').where("weekofyear", "==", weekprevious2).where("company", "==", user.company).get()
                .then(function (querySnapshot) {
                    let i = 0;
                    const _tmp: { [key: string]: number } = {}
                    _tmp['red'] = 0;
                    _tmp['yellow'] = 0;
                    _tmp['green'] = 0;
                    querySnapshot.forEach(function (doc) {
                        if (doc.data().quest_id == '-Kgs61AHOnpJ3rfyQr6t') {
                            _tmp['red'] += doc.data().red
                            _tmp['yellow'] += doc.data().yellow
                            _tmp['green'] += doc.data().green
                            i++
                        }
                        data2[doc.data().quest_id] = doc.data()
                    });
                    if (data2['-Kgs61AHOnpJ3rfyQr6t']) {
                        data2['-Kgs61AHOnpJ3rfyQr6t'].red = Math.ceil(_tmp['red'] / i)
                        data2['-Kgs61AHOnpJ3rfyQr6t'].yellow = Math.ceil(_tmp['yellow'] / i)
                        data2['-Kgs61AHOnpJ3rfyQr6t'].green = Math.ceil(_tmp['green'] / i)
                    }
                    resolve(data2);
                });
            });
            var promise1 = new Promise(function(resolve, reject) {
                const data1: { [key: string]: any; } = {}
                firebase.firestore().collection('insight_engagement_weekofyear').where("weekofyear", "==", weekprevious).where("company", "==", user.company).get()
                .then(function (querySnapshot) {
                    let i = 0;
                    const _tmp: { [key: string]: number } = {}
                    _tmp['red'] = 0;
                    _tmp['yellow'] = 0;
                    _tmp['green'] = 0;
                    querySnapshot.forEach(function (doc) {
                        if (doc.data().quest_id == '-Kgs61AHOnpJ3rfyQr6t') {
                            _tmp['red'] += doc.data().red
                            _tmp['yellow'] += doc.data().yellow
                            _tmp['green'] += doc.data().green
                            i++
                        }
                        data1[doc.data().quest_id] = doc.data()
                    });
                    if (data1['-Kgs61AHOnpJ3rfyQr6t']) {
                        data1['-Kgs61AHOnpJ3rfyQr6t'].red = Math.ceil(_tmp['red'] / i)
                        data1['-Kgs61AHOnpJ3rfyQr6t'].yellow = Math.ceil(_tmp['yellow'] / i)
                        data1['-Kgs61AHOnpJ3rfyQr6t'].green = Math.ceil(_tmp['green'] / i)
                    }
                    resolve(data1);
                });
            });
            
            Promise.all([promise1, promise2, promise3, promise4]).then((values)=> {
                const data1:any = values[0]
                const data2:any = values[1]
                const data3:any = values[2]
                const data4:any = values[3]
                const { questions } = state
                firebase.firestore().collection('insight_engagement').where("company", "==", user.company).get()
                    .then((querySnapshot) => {
                        querySnapshot.forEach((doc) => {
                            if(doc.data().quest_id !== '-Kgn7oxLPPWlbM_ZDc_h' && doc.data().quest_id !== '-Kgs549ClADmNQwoNbbG' && doc.data().quest_id !== '-L1FmpFO-v8IZc_B5EB7' && doc.data().quest_id !== '-L2ycGiBDo3rDGjLNKwW' && doc.data().quest_id !== '-LtOL_iR1N-ev2b_8Tmg'){
                                if (data1[doc.data().quest_id] != undefined) {
                                    if (doc.data().update == data1[doc.data().quest_id].update && data2[doc.data().quest_id]) {
                                        data1[doc.data().quest_id] = (data2[doc.data().quest_id]) ? data2[doc.data().quest_id] : undefined
                                    }
                                    _.forEach(questions, (value, index) => {
                                        if (value.quest_id == doc.data().quest_id) {
                                            questions[index].status.green = (doc.data().green) ? doc.data().green : 0
                                            questions[index].status.red = (doc.data().red) ? doc.data().red : 0
                                            questions[index].status.yellow = (doc.data().yellow) ? doc.data().yellow : 0
                                            questions[index].success = (isNaN(parseFloat(((((questions[index].status.green * 2) + (questions[index].status.yellow * 1)) / ((questions[index].status.green + questions[index].status.yellow + questions[index].status.red) * 2)) * 100).toFixed(1)))) ? 0 : ((((questions[index].status.green * 2) + (questions[index].status.yellow * 1)) / ((questions[index].status.green + questions[index].status.yellow + questions[index].status.red) * 2)) * 100).toFixed(1)
                                            if (data1[doc.data().quest_id]) {
                                                const cal: string = (isNaN(parseFloat(((((data1[doc.data().quest_id].green * 2) + (data1[doc.data().quest_id].yellow * 1)) / ((data1[doc.data().quest_id].green + data1[doc.data().quest_id].yellow + data1[doc.data().quest_id].red) * 2)) * 100).toFixed(1)))) ? '0' : ((((data1[doc.data().quest_id].green * 2) + (data1[doc.data().quest_id].yellow * 1)) / ((data1[doc.data().quest_id].green + data1[doc.data().quest_id].yellow + data1[doc.data().quest_id].red) * 2)) * 100).toFixed(1)
                                                const y = +cal;
                                                if (cal == questions[index].success)
                                                    questions[index].compare = 0
                                                else
                                                    questions[index].compare = Math.ceil((questions[index].success * 1) - (y * 1))
                                            }
                                        }
                                    });
                                }else{
                                    _.forEach(questions, (value, index) => {
                                        if (value.quest_id == doc.data().quest_id) {
                                            questions[index].status.green = (doc.data().green) ? doc.data().green : 0
                                            questions[index].status.red = (doc.data().red) ? doc.data().red : 0
                                            questions[index].status.yellow = (doc.data().yellow) ? doc.data().yellow : 0
                                            questions[index].success = (isNaN(parseFloat(((((questions[index].status.green * 2) + (questions[index].status.yellow * 1)) / ((questions[index].status.green + questions[index].status.yellow + questions[index].status.red) * 2)) * 100).toFixed(1)))) ? 0 : ((((questions[index].status.green * 2) + (questions[index].status.yellow * 1)) / ((questions[index].status.green + questions[index].status.yellow + questions[index].status.red) * 2)) * 100).toFixed(1)

                                            let dataQuestion =  {}
                                            firebase.firestore().collection('insight_engagement_weekofyear').where("company", "==", user.company).where("quest_id", "==", doc.data().quest_id).orderBy('weekofyear',"desc").limit(2).get()
                                            .then(function (querySnapshot) {
                                                querySnapshot.forEach(function (doc2) {
                                                    dataQuestion = doc2.data()
                                                });
                                                const cal: string = (isNaN(parseFloat(((((dataQuestion['green'] * 2) + (dataQuestion['yellow'] * 1)) / ((dataQuestion['green'] + dataQuestion['yellow'] + dataQuestion['red']) * 2)) * 100).toFixed(1)))) ? '0' : ((((dataQuestion['green'] * 2) + (dataQuestion['yellow'] * 1)) / ((dataQuestion['green'] + dataQuestion['yellow'] + dataQuestion['red']) * 2)) * 100).toFixed(1)
                                                const y = +cal;
                                                if (cal == questions[index].success)
                                                    questions[index].compare = 0
                                                else
                                                    questions[index].compare = Math.ceil((questions[index].success * 1) - (y * 1))
                                            });
                                        }
                                    });
                                }
                            }else{
                                if (data3[doc.data().quest_id] != undefined) {
                                    if (doc.data().update == data3[doc.data().quest_id].date && data4[doc.data().quest_id]) {
                                        data3[doc.data().quest_id] = (data4[doc.data().quest_id]) ? data4[doc.data().quest_id] : undefined
                                    }
                                    _.forEach(questions, (value, index) => {
                                        if (value.quest_id == doc.data().quest_id) {
                                            questions[index].status.green = (doc.data().green) ? doc.data().green : 0
                                            questions[index].status.red = (doc.data().red) ? doc.data().red : 0
                                            questions[index].status.yellow = (doc.data().yellow) ? doc.data().yellow : 0
                                            questions[index].success = (isNaN(parseFloat(((((questions[index].status.green * 2) + (questions[index].status.yellow * 1)) / ((questions[index].status.green + questions[index].status.yellow + questions[index].status.red) * 2)) * 100).toFixed(1)))) ? 0 : ((((questions[index].status.green * 2) + (questions[index].status.yellow * 1)) / ((questions[index].status.green + questions[index].status.yellow + questions[index].status.red) * 2)) * 100).toFixed(1)
                                            if (data3[doc.data().quest_id]) {
                                                const cal: string = (isNaN(parseFloat(((((data3[doc.data().quest_id].green * 2) + (data3[doc.data().quest_id].yellow * 1)) / ((data3[doc.data().quest_id].green + data3[doc.data().quest_id].yellow + data3[doc.data().quest_id].red) * 2)) * 100).toFixed(1)))) ? '0' : ((((data3[doc.data().quest_id].green * 2) + (data3[doc.data().quest_id].yellow * 1)) / ((data3[doc.data().quest_id].green + data3[doc.data().quest_id].yellow + data3[doc.data().quest_id].red) * 2)) * 100).toFixed(1)
                                                const y = +cal;
                                                if (cal == questions[index].success)
                                                    questions[index].compare = 0
                                                else
                                                    questions[index].compare = Math.ceil((questions[index].success * 1) - (y * 1))
                                            }
                                        }
                                    });
                                }else{
                                    _.forEach(questions, (value, index) => {
                                        if (value.quest_id == doc.data().quest_id) {
                                            questions[index].status.green = (doc.data().green) ? doc.data().green : 0
                                            questions[index].status.red = (doc.data().red) ? doc.data().red : 0
                                            questions[index].status.yellow = (doc.data().yellow) ? doc.data().yellow : 0
                                            questions[index].success = (isNaN(parseFloat(((((questions[index].status.green * 2) + (questions[index].status.yellow * 1)) / ((questions[index].status.green + questions[index].status.yellow + questions[index].status.red) * 2)) * 100).toFixed(1)))) ? 0 : ((((questions[index].status.green * 2) + (questions[index].status.yellow * 1)) / ((questions[index].status.green + questions[index].status.yellow + questions[index].status.red) * 2)) * 100).toFixed(1)
                                            let dataQuestion =  {}
                                            firebase.firestore().collection('insight_engagement_monthofyear').where("company", "==", user.company).where("quest_id", "==", doc.data().quest_id).orderBy('date',"desc").limit(2).get()
                                            .then(function (querySnapshot) {
                                                querySnapshot.forEach(function (doc2) {
                                                    dataQuestion = doc2.data()
                                                });
                                                const cal: string = (isNaN(parseFloat(((((dataQuestion['green'] * 2) + (dataQuestion['yellow'] * 1)) / ((dataQuestion['green'] + dataQuestion['yellow'] + dataQuestion['red']) * 2)) * 100).toFixed(1)))) ? '0' : ((((dataQuestion['green'] * 2) + (dataQuestion['yellow'] * 1)) / ((dataQuestion['green'] + dataQuestion['yellow'] + dataQuestion['red']) * 2)) * 100).toFixed(1)
                                                const y = +cal;
                                                if (cal == questions[index].success)
                                                    questions[index].compare = 0
                                                else
                                                    questions[index].compare = Math.ceil((questions[index].success * 1) - (y * 1))
                                            });
                                        }
                                    });
                                }
                            }
                            
                        });
                        ///SET DEFAULT SORT BY
                        setTimeout(() => {
                            state.questions = state.questions.sort((a, b) => { return (b.success - a.success) * -1; });
                        }, 1000);
                    });
            });
        },
        sortBy({ commit, state }: any, type: string) {
            if (type == 'lowest') {
                state.questions = state.questions.sort((a, b) => { return (b.success - a.success) * -1; });
            } else if (type == 'highest') {
                state.questions = state.questions.sort((a, b) => { return b.success - a.success; });
            }
        },
        async getTalkPointsDaily({ commit, state, rootState }: any, user: any) {
            const data:any = []
            const dateNow = new Date()
            const startDate = format(addDays(dateNow, -7), 'YYYY-MM-DD')
            const endDate = format(addDays(dateNow, -1), 'YYYY-MM-DD')
            if(state.talking_points_daily.length == 0){
                await firebase.firestore().collection('talking_points_day').where("company", "==", user.company).where("date", ">=", startDate).where("date", "<=", endDate).get()
                .then(function (querySnapshot) {
                    querySnapshot.forEach(function (doc) {
                        const _data = doc.data();
                        if(_data.response){
                            for(const index in _data.response){
                                let density = Number(_data.response[index].density)
                                let priority = Number(_data.response[index].priority)
                                if(density >= 0.4 && priority <= 4){
                                    data.push(_data.response[index])
                                }
                            }
                        }
                    });
                    const dataSort = _.orderBy(data,['density'], ['desc'])
                    commit('setTalkingPointsDaily', dataSort)
                });
            }
            // if(rootState.authen.user.email && state.talking_points_daily.length == 0){
            //     await axios.get(`${ apiUrl }/talkingpoint/get/daily/${user.company}`).then(response => {
            //         const data = response.data
            //         _.forEach(data, (value, index) => {
            //             data[index].dt = format(data[index].dt, 'YYYY-MM-DD');
            //         });
            //         data.sort((a, b) => { return b.word_score - a.word_score; });
            //         commit('setTalkingPointsDaily', data)
            //       })
            //     .catch(function (error) {
            //         console.log(error);
            //     });
            // }
        },
        async getDataTalkingPointsMonthly({ commit, dispatch, rootState, state }: any, user: any) {
            const dateNow = new Date()
            let arrData = {}
            if(Object.keys(state.talking_points_monthly).length == 0){
                var promise1 = new Promise(function(resolve, reject) {
                    const data1: { [key: string]: firebase.firestore.DocumentData; } = {}
                    firebase.firestore().collection('talking_points_day').where("company", "==", user.company).get()
                    .then(function (querySnapshot) {
                        querySnapshot.forEach(function (doc) {
                            const _data = doc.data();
                            if(_data.response){
                                for(const index in _data.response){
                                    let density = Number(_data.response[index].density)
                                    let priority = Number(_data.response[index].priority)
                                    if(density >= 0.4 && priority <= 4){
                                        let monthyear = format(_data.date, 'YYYY-MM');
                                        if(arrData[monthyear] == undefined){
                                            arrData[monthyear] = new Array()
                                        }
                                        arrData[monthyear].push(_data.response[index])
                                        _.forEach(arrData, (value, index) => {
                                            arrData[index].sort((a, b) => { return b.density - a.density; });
                                        });
                                    }
                                }
                            }
                        });
                        resolve(data1);
                    });
                });
                var promise2 = new Promise(function(resolve, reject) {
                    const data2: { [key: string]: firebase.firestore.DocumentData; } = {}
                    axios.get(`${ apiUrl }/talkingpoint/get/monthly/${user.company}`).then(response => {
                        const data = response.data
                        _.forEach(data, (value, index) => {
                            let monthyear = format(data[index].dt, 'YYYY-MM');
                            data[index].dt = format(data[index].dt, 'YYYY-MM-DD');
                            if(monthyear < '2024-12'){
                                if(arrData[monthyear] == undefined){
                                    arrData[monthyear] = new Array()
                                }
                                arrData[monthyear].push(data[index])
                            }
                        });
                        _.forEach(arrData, (value, index) => {
                            arrData[index].sort((a, b) => { return b.word_score - a.word_score; });
                        });
                        resolve(data2);
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
                });
                Promise.all([promise1, promise2]).then((values)=> {
                    const sortedData = Object.fromEntries(
                        Object.entries(arrData).sort(([keyA], [keyB]) => {
                          return keyB.localeCompare(keyA);
                        })
                      );
                    commit('setTalkingPointsMonthly', sortedData)
                });
            }
            // if(rootState.authen.user.email && Object.keys(state.talking_points_monthly).length == 0){
            //     await axios.get(`${ apiUrl }/talkingpoint/get/monthly/${user.company}`).then(response => {
            //         const data = response.data
            //         let arrData = {}
            //         _.forEach(data, (value, index) => {
            //             let monthyear = format(data[index].dt, 'YYYY-MM');
            //             data[index].dt = format(data[index].dt, 'YYYY-MM-DD');
            //             if(arrData[monthyear] == undefined){
            //                 arrData[monthyear] = new Array()
            //             }
            //             arrData[monthyear].push(data[index])
            //         });
            //         _.forEach(arrData, (value, index) => {
            //             arrData[index].sort((a, b) => { return b.word_score - a.word_score; });
            //         });
            //         commit('setTalkingPointsMonthly', arrData)
            //       })
            //     .catch(function (error) {
            //         console.log(error);
            //     });
            // }
        },
        async getDataTalkingPoints30D({ commit, dispatch, rootState, state }: any, dataObj: any) {
            const data:any = []
            const dateNow = new Date()
            const startDate = format(addDays(dateNow, -30), 'YYYY-MM-DD')
            const endDate = format(addDays(dateNow, -1), 'YYYY-MM-DD')
            const user = dataObj.user;
            const category_id = dataObj.category_id;
            await firebase.firestore().collection('talking_points_30d').where("company", "==", user.company).where("category_id","==",category_id).where("date", ">=", startDate).where("date", "<=", endDate).get()
            .then(function (querySnapshot) {
                querySnapshot.forEach(function (doc) {
                    const _data = doc.data();
                    if(_data.response){
                        for(const index in _data.response){
                            let density = Number(_data.response[index].density)
                            let priority = Number(_data.response[index].priority)
                            if(density >= 0.4 && priority <= 4){
                                data.push(_data.response[index])
                            }
                        }
                    }
                });
                const dataSort = _.orderBy(data,['density'], ['desc'])
                commit('setTalkingPoints30D', dataSort)
            })
            // if(rootState.authen.user.email){
            //     const user = dataObj.user;
            //     const category_id = dataObj.category_id;
            //     await axios.get(`${ apiUrl }/talkingpoint/get/30d/${category_id}/${user.company}`).then(response => {
            //         const data = response.data
            //         _.forEach(data, (value, index) => {
            //             data[index].dt = format(data[index].dt, 'YYYY-MM-DD');
            //         });
            //         data.sort((a, b) => { return b.word_score - a.word_score; });
            //         commit('setTalkingPoints30D', data)
            //       })
            //     .catch(function (error) {
            //         console.log(error);
            //     });
            // }
        },
        async getDataEngagementScore({ commit, state }: any, user: any) {
            commit('setEngagementScoreLoadingStatus', true);
            let dataChart = {};
            dataChart['company'] = [];
            dataChart['manager'] = [];
            dataChart['leader'] = [];
            dataChart['labels'] = [];
            dataChart['newLabels'] = [];
            dataChart['date'] = [];
            const dateStart = format(addDays(new Date(), -90), 'YYYY-MM-DD')
            const dateEnd = format(addDays(new Date(), -1), 'YYYY-MM-DD')
            let labelCheck:any = [];
            let doubleCheck:any = [];
            await firebase.firestore().collection('engagement_index_7day_rolling_company').where("company", "==", user.company).where("date", ">=", dateStart).where("date", "<=", dateEnd).get()
            .then(function (querySnapshot) {
                querySnapshot.forEach(function (doc) {
                    const data = doc.data();
                    let Month = format(data.date, 'MMM')
                    if(labelCheck[Month] == undefined){
                        labelCheck[Month] = true
                        dataChart['labels'].push(Month)
                        doubleCheck[dataChart['labels'].length - 1] = true
                    }else{
                        dataChart['labels'].push('')
                    }
                    const dateLabel = format(data.date, 'D MMMM YY')
                    dataChart['newLabels'].push(dateLabel)
                    dataChart['date'].push(dateLabel)
                    dataChart['company'].push((data.company_DEBI) ? Number(data.company_DEBI.toFixed(0)) : 0)
                    dataChart['manager'].push((data.manager_DEBI) ? Number(data.manager_DEBI.toFixed(0)) : 0)
                    dataChart['leader'].push((data.leader_DEBI) ? Number(data.leader_DEBI.toFixed(0)) : 0)
                });
                if(Object.keys(doubleCheck).length > 3){
                    dataChart['labels'][Object.keys(doubleCheck)[0]] = ''
                }
                let maxScore = Math.max(
                    ...dataChart['company'],
                    ...dataChart['manager'],
                    ...dataChart['leader']
                );
                dataChart['maxScore'] = maxScore
                commit('setEngagementScoreLoadingStatus', false);
                commit('setChartEngagementScore', dataChart);
            });
        },
        async getDataJobTenure({ commit, state }: any, user: any) {
            commit('setDatabarchartLoadingStatus', true);
            let dataChart = {};
            firebase.firestore().collection('insight_job_tenure').where("company", "==", user.company).get()
            .then(function (querySnapshot) {
                querySnapshot.forEach(function (doc) {
                    const data = doc.data();
                    dataChart['labels'] = data['label']

                    // calculate from total
                    let index = 0
                    dataChart['active'] = [];
                    dataChart['people_count'] = [];
                    dataChart['happy'] = [];
                    dataChart['worse'] = [];
                    dataChart['feedback'] = [];
                    do{
                        dataChart['people_count'].push(data['active_'+index])
                        if(!data['total'][index] || data['total'][index] == 0){
                            dataChart['active'].push(0)
                        }else{
                            let cal_active = Math.ceil((data['active_'+index] * 100) / data['total'][index])
                            dataChart['active'].push((cal_active > 100) ? 100 : cal_active)
                        }

                        if(!data['happy_total_'+index] || data['happy_total_'+index] == 0){
                            dataChart['happy'].push(0)
                            dataChart['worse'].push(0)
                        }else{
                            let cal_happy = Math.ceil((data['happy_'+index] * 100) / data['happy_total_'+index])
                            let cal_worse = Math.ceil((data['worse_'+index] * 100) / data['happy_total_'+index])
                            dataChart['happy'].push((cal_happy > 100) ? 100 : cal_happy)
                            dataChart['worse'].push((cal_worse > 100) ? 100 : cal_worse)
                        }
                        
                        if(!data['feedback_total_'+index] || data['feedback_total_'+index] == 0){
                            dataChart['feedback'].push(0)
                        }else{
                            let cal_feedback = Math.ceil((data['feedback_'+index] * 100) / data['feedback_total_'+index])
                            dataChart['feedback'].push((cal_feedback > 100) ? 100 : cal_feedback)
                        }
                        index++
                    }
                    while(index < 5)
                });
                commit('setDatabarchartLoadingStatus', false);
                commit('setChartJobTenure', dataChart);
            });
            
        },
        async getDataKeyGroup({ commit, state }: any, user: any) {
            commit('setDatakeygroupLoadingStatus', true);
            const teamGroup: Array<any> = [];
            const tenureGroup: Array<any> = [];
            const keyGroupArr: Array<any> = [];
            const arrData: Array<any> = [];
            firebase.firestore().collection('insight_key_groups').where("company", "==", user.company).get()
            .then(function (querySnapshot) {
                querySnapshot.forEach(function (doc) {
                    const data = doc.data();
                    data.key = doc.id
                    keyGroupArr.push(data)
                });

                // Priority 1
                let HighRisk = _.filter(keyGroupArr, el => (el.categories == 'Risk') && (el.qty > 2) && (el.rate > 0.35));
                if(HighRisk.length > 0){
                    HighRisk = _.orderBy(HighRisk,['qty', 'rate'], ['desc', 'desc'])
                    HighRisk[0]['desc_text'] = 'HIGH RISK'
                    HighRisk[0]['emotion'] = 'bad'
                    arrData.push(HighRisk[0])
                }
                // Priority 2
                let LowActivity = _.filter(keyGroupArr, el => (el.categories == 'Activity') && (el.qty > 2) && (el.rate < 0.30));
                if(LowActivity.length > 0){
                    LowActivity = _.orderBy(LowActivity,['qty', 'rate'], ['desc', 'asc'])
                    LowActivity[0]['desc_text'] = 'LOW ACTIVITY'
                    LowActivity[0]['emotion'] = 'low_activity'
                    arrData.push(LowActivity[0])
                }
                // Priority 3
                let LowFeedback = _.filter(keyGroupArr, el => (el.categories == 'Feedback') && (el.qty > 2) && (el.rate < 0.20));
                if(LowFeedback.length > 0){
                    LowFeedback = _.orderBy(LowFeedback,['qty', 'rate'], ['desc', 'asc'])
                    LowFeedback[0]['desc_text'] = 'LOW FEEDBACK'
                    LowFeedback[0]['emotion'] = 'low_feedback'
                    arrData.push(LowFeedback[0])
                }
                // Priority 4
                let LowHappiness = _.filter(keyGroupArr, el => (el.categories == 'Happiness') && (el.qty > 2) && (el.rate < 0.10));
                if(LowHappiness.length > 0){
                    LowHappiness = _.orderBy(LowHappiness,['qty', 'rate'], ['desc', 'asc'])
                    LowHappiness[0]['desc_text'] = 'LOW HAPPINESS'
                    LowHappiness[0]['emotion'] = 'bad'
                    arrData.push(LowHappiness[0])
                }
                // Priority 5
                let HighActivity = _.filter(keyGroupArr, el => (el.categories == 'Activity') && (el.qty > 2) && (el.rate > 0.90));
                if(HighActivity.length > 0){
                    HighActivity = _.orderBy(HighActivity,['qty', 'rate'], ['desc', 'desc'])
                    HighActivity[0]['desc_text'] = 'HIGH ACTIVITY'
                    HighActivity[0]['emotion'] = 'good'
                    arrData.push(HighActivity[0])
                }
                // Priority 6
                let HighFeedback = _.filter(keyGroupArr, el => (el.categories == 'Feedback') && (el.qty > 2) && (el.rate > 0.80));
                if(HighFeedback.length > 0){
                    HighFeedback = _.orderBy(HighFeedback,['qty', 'rate'], ['desc', 'desc'])
                    HighFeedback[0]['desc_text'] = 'HIGH FEEDBACK'
                    HighFeedback[0]['emotion'] = 'good'
                    arrData.push(HighFeedback[0])
                }
                // Priority 7
                let HighHappiness = _.filter(keyGroupArr, el => (el.categories == 'Happiness') && (el.qty > 2) && (el.rate > 0.90));
                if(HighHappiness.length > 0){
                    HighHappiness = _.orderBy(HighHappiness,['qty', 'rate'], ['desc', 'desc'])
                    HighHappiness[0]['desc_text'] = 'HIGH HAPPINESS'
                    HighHappiness[0]['emotion'] = 'good'
                    arrData.push(HighHappiness[0])
                }
                // Priority 8
                let LowRisk = _.filter(keyGroupArr, el => (el.categories == 'Risk') && (el.qty > 2) && (el.rate == 0));
                if(LowRisk.length > 0){
                    LowRisk = _.orderBy(LowRisk,['qty'], ['desc'])
                    LowRisk[0]['desc_text'] = 'LOW RISK'
                    LowRisk[0]['emotion'] = 'good'
                    arrData.push(LowRisk[0])
                }
                commit('setDatakeygroupLoadingStatus', false);
                commit('setDataKeyGroup', arrData.slice(0, 10))
            });
        },
        getDataChart({ commit, state }: any, dataObj: any) {
            const user:any = dataObj.user;
            const quest_id = dataObj.quest_id;
            if(quest_id){
                const dateNow = new Date()
                const dateToday = format(dateNow, 'YYYY-MM-DD');
                let dataInsight: Array<any> = [];
                const response: Array<any> = [];
                const success: Array<any> = [];
                const newLabel: Array<any> = [];
                const optionsMonthName: Array<any> = [];
                const optionsMonth: Array<any> = [];
                if(quest_id != '-Kgs61AHOnpJ3rfyQr6t'){
                    for(let i = 12; i > 0; i--){
                        optionsMonthName.push(format(subMonths(dateNow,i - 1), 'MMM').toUpperCase())
                        const m = format(subMonths(dateNow,i - 1), 'YYYY-MM')
                        const daterange = {
                            month_of_year: format(subMonths(dateNow,i - 1), 'YYYY-MM'),
                        } 
                        optionsMonth.push(daterange)
                    }
                }
                if(quest_id == '-Kgs61AHOnpJ3rfyQr6t'){
                    const optionsDayName: Array<any> = [];
                    let masterDay: Array<any> = [];
                    for (let m = 31; m > 0; m--) {
                        masterDay.push(format(addDays(dateNow, -(m - 1)), 'YYYY-MM-DD'))
                        optionsDayName.push(format(addDays(dateNow, -(m - 1)), 'DD MMM'))
                    }
                    commit('setOptMonthName', optionsDayName)
                    const data1: { [key: string]: any; } = {}
                    firebase.firestore().collection('insight_engagement_day').where("company", "==", user.company).where("quest_id","==",quest_id).where("date", ">=", format(addDays(new Date(), -30), 'YYYY-MM-DD')).where("date", "<", format(new Date(), 'YYYY-MM-DD')).orderBy('date', 'asc').get()
                    .then(function (querySnapshot) {
                        querySnapshot.forEach(function (doc) {
                            const _data = doc.data()
                            const _tmp: { [key: string]: number } = {}
                            _tmp['red'] = (doc.data().red) ? doc.data().red : 0
                            _tmp['yellow'] = (doc.data().yellow) ? doc.data().yellow : 0
                            _tmp['green'] = (doc.data().green) ? doc.data().green : 0
                            _data.success = (isNaN(parseFloat(((((_tmp['green'] * 2) + (_tmp['yellow'] * 1)) / ((_tmp['green'] + _tmp['yellow'] + _tmp['red']) * 2)) * 100).toFixed(1)))) ? 0 : ((((_tmp['green'] * 2) + (_tmp['yellow'] * 1)) / ((_tmp['green'] + _tmp['yellow'] + _tmp['red']) * 2)) * 100).toFixed(1)
                            data1[doc.data().date] = _data
                        });
                        let lastexists:any = ""
                        let lastall: Array<any> = [];
                        lastall['date'] = ''
                        lastall['success'] = 0
                        // get last data
                        firebase.firestore().collection('insight_engagement_weekofyear').where("company", "==", user.company).where("quest_id","==",quest_id).where("update","<=",masterDay[0]).orderBy('update', 'desc').limit(1).get()
                        .then(function (querySnapshot) {
                            querySnapshot.forEach(function (doc) {
                                const _data = doc.data()
                                const _tmp: { [key: string]: number } = {}
                                _tmp['red'] = (doc.data().red) ? doc.data().red : 0
                                _tmp['yellow'] = (doc.data().yellow) ? doc.data().yellow : 0
                                _tmp['green'] = (doc.data().green) ? doc.data().green : 0
                                _data.success = (isNaN(parseFloat(((((_tmp['green'] * 2) + (_tmp['yellow'] * 1)) / ((_tmp['green'] + _tmp['yellow'] + _tmp['red']) * 2)) * 100).toFixed(1)))) ? 0 : ((((_tmp['green'] * 2) + (_tmp['yellow'] * 1)) / ((_tmp['green'] + _tmp['yellow'] + _tmp['red']) * 2)) * 100).toFixed(1)
                                lastall['success'] = _data.success
                                lastall['date'] = _data.update
                            });
                            firebase.firestore().collection('insight_engagement_weekofyear').where("company", "==", user.company).where("quest_id","==",quest_id).where("update",">=",format(addDays(new Date(), -30), 'YYYY-MM-DD')).orderBy('update', 'desc').get()
                            .then(function (querySnapshot) {
                                querySnapshot.forEach(function (doc) {
                                    const _data2 = doc.data()
                                    const _tmp: { [key: string]: number } = {}
                                    _tmp['red'] = (doc.data().red) ? doc.data().red : 0
                                    _tmp['yellow'] = (doc.data().yellow) ? doc.data().yellow : 0
                                    _tmp['green'] = (doc.data().green) ? doc.data().green : 0
                                    _data2.success = (isNaN(parseFloat(((((_tmp['green'] * 2) + (_tmp['yellow'] * 1)) / ((_tmp['green'] + _tmp['yellow'] + _tmp['red']) * 2)) * 100).toFixed(1)))) ? 0 : ((((_tmp['green'] * 2) + (_tmp['yellow'] * 1)) / ((_tmp['green'] + _tmp['yellow'] + _tmp['red']) * 2)) * 100).toFixed(1)
                                    data1[doc.data().update] = _data2
                                });
                                _.forEach(masterDay, (day, index) => {
                                    let txtTooltips = ""
                                    txtTooltips = optionsDayName[index]
                                    newLabel.push(txtTooltips)
                                    const _tmp: { [key: string]: number } = {}
                                    if(data1[day] && (data1[day].success || data1[day].success == '0')){
                                        _tmp['sumsuccess'] = data1[day].success
                                        lastexists = _tmp['sumsuccess']
                                    }else{
                                        if(lastexists || lastexists == '0'){
                                            _tmp['sumsuccess'] = lastexists
                                        }else if(day >= lastall['date']){
                                            _tmp['sumsuccess'] = lastall['success']
                                        }else{
                                            _tmp['sumsuccess'] = 0
                                        }
                                    }
                                    // _tmp['sumsuccess'] = (data1[day] && data1[day].success) ? data1[day].success : 0
                                    success.push(_tmp['sumsuccess'])
                                });
                                response['success'] = success
                                commit('setNewLabel',newLabel)
                                commit('setChartSuccessScore', response)
                            });
                        });
                    });
                } else if(quest_id !== '-Kgn7oxLPPWlbM_ZDc_h' && quest_id !== '-Kgs549ClADmNQwoNbbG' && quest_id !== '-L1FmpFO-v8IZc_B5EB7' && quest_id !== '-L2ycGiBDo3rDGjLNKwW' && quest_id !== '-LtOL_iR1N-ev2b_8Tmg'){
                    const { questions } = state
                    let questionsData = _.find(questions, ['quest_id', quest_id]);
                    if(questionsData && questionsData.repeat_days){
                        let arrDay = {
                            Sun: 0,
                            Mon: 1,
                            Tue: 2,
                            Wed: 3,
                            Thu: 4,
                            Fri: 5,
                            Sat: 6,
                        }
                        let dayStart:any = Object.keys(questionsData.repeat_days).filter(k=>questionsData.repeat_days[k]==="Y")
                        let masterMonth: Array<any> = [];
                        let masterMonth_fix: Array<any> = [];
                        if(dayStart && dayStart[0]){
                            for (let m = 0; m < optionsMonth.length; m++) {
                                let splitDate: Array<any> = [];
                                splitDate = optionsMonth[m]['month_of_year'].split("-")
                                let firstOfMonth = new Date(splitDate[0], splitDate[1] - 1, 1);
                                let startweekofmonth:any = format(startOfWeek(firstOfMonth,{weekStartsOn:Number(arrDay[dayStart[0]])}), 'YYYY-MM-DD')
                                if(startweekofmonth.substr(0, 7) < optionsMonth[m]['month_of_year']){
                                    startweekofmonth = format(startOfWeek(addDays(startweekofmonth, 7),{weekStartsOn:Number(arrDay[dayStart[0]])}), 'YYYY-MM-DD')
                                }
                                do{
                                    let startweekofyear = format(startOfWeek(startweekofmonth,{weekStartsOn:Number(arrDay[dayStart[0]])}), 'GGGG-W')
                                    let startweekofyear_fix = format(startOfWeek(startweekofmonth,{weekStartsOn:Number(arrDay[dayStart[0]])}), 'GGGG-WW')
                                    startweekofmonth = format(startOfWeek(addDays(startweekofmonth, 7),{weekStartsOn:Number(arrDay[dayStart[0]])}), 'YYYY-MM-DD')
                                    if(masterMonth[m] == undefined){
                                        masterMonth[m] = new Array()
                                    }
                                    masterMonth[m].push(startweekofyear)
                                    if(masterMonth_fix[m] == undefined){
                                        masterMonth_fix[m] = new Array()
                                    }
                                    masterMonth_fix[m].push(startweekofyear_fix)
                                }
                                while(startweekofmonth.substr(0, 7) == optionsMonth[m]['month_of_year'] && startweekofmonth <= dateToday)
                            }
                            
                            let lastIndex = masterMonth.length - 1
                            let start_week_of_year = masterMonth[0][0]
                            let start_week_of_year_fix = masterMonth_fix[0][0]
                            let end_week_of_year = masterMonth[lastIndex][masterMonth[lastIndex].length - 1]
                            const data1: { [key: string]: any; } = {}
                            firebase.firestore().collection('insight_engagement_weekofyear').where("company", "==", user.company).where("quest_id","==",quest_id).where('weekofyear', '>=', start_week_of_year_fix).orderBy('weekofyear', 'asc').get()
                            .then(function (querySnapshot) {
                                querySnapshot.forEach(function (doc) {
                                    const _data = doc.data()
                                    const _tmp: { [key: string]: number } = {}
                                    _tmp['red'] = (doc.data().red) ? doc.data().red : 0
                                    _tmp['yellow'] = (doc.data().yellow) ? doc.data().yellow : 0
                                    _tmp['green'] = (doc.data().green) ? doc.data().green : 0
                                    _data.success = (isNaN(parseFloat(((((_tmp['green'] * 2) + (_tmp['yellow'] * 1)) / ((_tmp['green'] + _tmp['yellow'] + _tmp['red']) * 2)) * 100).toFixed(1)))) ? 0 : ((((_tmp['green'] * 2) + (_tmp['yellow'] * 1)) / ((_tmp['green'] + _tmp['yellow'] + _tmp['red']) * 2)) * 100).toFixed(1)
                                    data1[doc.data().weekofyear] = _data
                                });
                                const optionsWeekOfMonthName: Array<any> = [];
                                let lastexists:any = ""
                                let lastall: Array<any> = [];
                                lastall['date'] = ''
                                lastall['success'] = 0
                                // get last data
                                firebase.firestore().collection('insight_engagement_weekofyear').where("company", "==", user.company).where("quest_id","==",quest_id).where('weekofyear', '<=', masterMonth[0][0]).orderBy('weekofyear', 'desc').limit(1).get()
                                .then(function (querySnapshot) {
                                    querySnapshot.forEach(function (doc) {
                                        const _data = doc.data()
                                        const _tmp: { [key: string]: number } = {}
                                        _tmp['red'] = (doc.data().red) ? doc.data().red : 0
                                        _tmp['yellow'] = (doc.data().yellow) ? doc.data().yellow : 0
                                        _tmp['green'] = (doc.data().green) ? doc.data().green : 0
                                        _data.success = (isNaN(parseFloat(((((_tmp['green'] * 2) + (_tmp['yellow'] * 1)) / ((_tmp['green'] + _tmp['yellow'] + _tmp['red']) * 2)) * 100).toFixed(1)))) ? 0 : ((((_tmp['green'] * 2) + (_tmp['yellow'] * 1)) / ((_tmp['green'] + _tmp['yellow'] + _tmp['red']) * 2)) * 100).toFixed(1)
                                        _tmp['sumsuccess'] = _data.success
                                        lastall['success'] = _tmp['sumsuccess']
                                        let splitData = _data.weekofyear.split('-')
                                        lastall['date'] = splitData[1].length == 1 ? splitData[0]+'-'+'0'+splitData[1] : splitData[0]+'-'+splitData[1]
                                    });
                                    _.forEach(masterMonth, (week, index) => {
                                        optionsWeekOfMonthName.push(optionsMonthName[index])
                                        let numweek = 1
                                        _.forEach(week, (i_weekyear, w_index) => {
                                            if(week.length !== (w_index + 1)){
                                                optionsWeekOfMonthName.push("")
                                            }
                                            let txtTooltips = ""
                                            txtTooltips = optionsMonthName[index] + " : " + "Week " + numweek
                                            newLabel.push(txtTooltips)
                                            const _tmp: { [key: string]: number } = {}
                                            if(data1[i_weekyear] && (data1[i_weekyear].success || data1[i_weekyear].success == '0')){
                                                _tmp['sumsuccess'] = data1[i_weekyear].success
                                                lastexists = _tmp['sumsuccess']
                                            }else{
                                                let splitData2 = i_weekyear
                                                let checkweek = splitData2[1].length == 1 ? splitData2[0]+'-'+'0'+splitData2[1] : splitData2[0]+'-'+splitData2[1]
                                                if(lastexists || lastexists == '0'){
                                                    _tmp['sumsuccess'] = lastexists
                                                }else if(checkweek >= lastall['date']){
                                                    _tmp['sumsuccess'] = lastall['success']
                                                }else{
                                                    _tmp['sumsuccess'] = 0
                                                }
                                            }
                                            // _tmp['sumsuccess'] = (data1[i_weekyear] && data1[i_weekyear].success) ? data1[i_weekyear].success : 0
                                            success.push(_tmp['sumsuccess'])
                                            numweek++
                                        });
                                    });
                                    response['success'] = success
                                    commit('setChartSuccessScore', response)
                                    commit('setOptMonthName', optionsWeekOfMonthName)
                                    commit('setNewLabel',newLabel)
                                });
                            });
                        }
                    }
                }else{
                    commit('setOptMonthName', optionsMonthName)
                    const startdate = format(addMonths(dateNow,-11), "YYYY-MM")+'-01'
                    const enddate = format(dateNow, "YYYY-MM")+'-31'
                    firebase.firestore().collection('insight_engagement_monthofyear').where("company", "==", user.company).where("quest_id","==",quest_id).where("date", ">=", startdate).where("date", "<", enddate).orderBy('date', 'asc').get()
                    .then(function (querySnapshot) {
                        querySnapshot.forEach(function (doc) {
                            const data = doc.data();
                            if(data.total && data.answer){
                                data.success = Math.ceil((data.answer / data.total) * 100)
                            }else{
                                data.success = (isNaN(parseFloat(((((data.green * 2) + (data.yellow * 1)) / ((data.green + data.yellow + data.red) * 2)) * 100).toFixed(1)))) ? 0 : ((((data.green * 2) + (data.yellow * 1)) / ((data.green + data.yellow + data.red) * 2)) * 100).toFixed(1)
                            }
                            dataInsight.push(data);
                        });
                        let lastexists:any = ""
                        let lastall: Array<any> = [];
                        lastall['date'] = ''
                        lastall['success'] = 0
                        // get last data
                        firebase.firestore().collection('insight_engagement_monthofyear').where("company", "==", user.company).where("quest_id","==",quest_id).where('date','<=',optionsMonth[0]['month_of_year']+"-01").orderBy('date', 'desc').limit(1).get()
                        .then(function (querySnapshot) {
                            querySnapshot.forEach(function (doc) {
                                const data = doc.data();
                                if(data.total && data.answer){
                                    data.success = Math.ceil((data.answer / data.total) * 100)
                                }else{
                                    data.success = (isNaN(parseFloat(((((data.green * 2) + (data.yellow * 1)) / ((data.green + data.yellow + data.red) * 2)) * 100).toFixed(1)))) ? 0 : ((((data.green * 2) + (data.yellow * 1)) / ((data.green + data.yellow + data.red) * 2)) * 100).toFixed(1)
                                }
                                lastall['success'] = data.success
                                lastall['date'] = data.date
                            });
                            for (let m = 0; m < optionsMonth.length; m++) {
                                let txtTooltips = ""
                                txtTooltips = optionsMonthName[m]
                                newLabel.push(txtTooltips)
                                const _tmp: { [key: string]: number } = {}
                                _tmp['sumsuccess'] = 0
                                _tmp['rows'] = 0
                                for (let index = 0; index < dataInsight.length; index++) {
                                    const element = dataInsight[index];
                                    if (element.date.substr(0, 7) == optionsMonth[m]['month_of_year']) {
                                        _tmp['sumsuccess'] = element.success
                                        lastexists = _tmp['sumsuccess']
                                    }else{
                                        if(lastexists || lastexists == '0'){
                                            _tmp['sumsuccess'] = lastexists
                                        }else if(optionsMonth[m]['month_of_year'] >= lastall['date'].substr(0, 7)){
                                            _tmp['sumsuccess'] = lastall['success']
                                        }else{
                                            _tmp['sumsuccess'] = 0
                                        }
                                    }
                                }
                                success.push(_tmp['sumsuccess'])
                                response['success'] = success
                            }
                            commit('setNewLabel',newLabel)
                            commit('setChartSuccessScore', response)
                        });
                    });
                }
            }
        },
        async getDataToneAnalyze({commit,state}:any,user:any){
            commit('setToneLoadingStatus', true);
            const dateNow = new Date();
            const _dateNow=format(new Date(dateNow), 'YYYY-MM-DD')
            const sevenago=format( dateNow.setDate(dateNow.getDate() - 7),"YYYY-MM-DD");
            const fourteenago=format( new Date().setDate(new Date().getDate() - 14),"YYYY-MM-DD");
            const sumTone={
                sum:0,
                anger:0,
                fear:0,
                joy :0,
                sadness:0,
                analytical:0,
                confident:0,
                tentative :0,
                frustrated :0,
                satisfied:0,
                excited:0,
                polite:0,
                impolite:0,
                sympathetic:0,
                disheartening:0,
                sad:0,
                accusatory:0,
                disapproving:0,
                appreciative:0,
                encouraging:0,
                unassuming:0,
                concerned:0,
                egocentric:0,
                optimistic:0,
                joyful:0,
                curious:0,
                formal:0,
                friendly:0,
                respectful:0,
                empathetic:0,
                patient:0,
                collaborative:0,
                open_minded:0,
                constructive:0,
                aggressive:0,
                condescending:0,
                passive_aggressive:0,
                impatient:0,
                dismissive:0,
                sarcastic:0,
                defensive:0,
                rude:0,
                gossiping:0,
                overly_critical:0,
                
            }
            const sumToneAgo={
                    sum:0,
                    anger:0,
                    fear:0,
                    joy :0,
                    sadness:0,
                    analytical:0,
                    confident:0,
                    tentative :0,
                    frustrated :0,
                    satisfied:0,
                    excited:0,
                    polite:0,
                    impolite:0,
                    sympathetic:0,
                    disheartening:0,
                    sad:0,
                    accusatory:0,
                    disapproving:0,
                    appreciative:0,
                    encouraging:0,
                    unassuming:0,
                    concerned:0,
                    egocentric:0,
                    optimistic:0,
                    joyful:0,
                    curious:0,
                    formal:0,
                    friendly:0,
                    respectful:0,
                    empathetic:0,
                    patient:0,
                    collaborative:0,
                    open_minded:0,
                    constructive:0,
                    aggressive:0,
                    condescending:0,
                    passive_aggressive:0,
                    impatient:0,
                    dismissive:0,
                    sarcastic:0,
                    defensive:0,
                    rude:0,
                    gossiping:0,
                    overly_critical:0,
                }
            const _emoji=[
                {
                    toneId: 'anger',
                    emoji: '😡',
                    emojiText: 'Anger',
                    details: 'Anger is evoked due to injustice, conflict, humiliation, negligence, or betrayal. If anger is active, the individual attacks the target, verbally or physically. If anger is passive, the person silently sulks and feels tension and hostility.'
                },
                {
                    toneId: 'fear',
                    emoji: '😨',
                    emojiText: 'Fear',
                    details: 'Fear is a response to impending danger. It is a survival mechanism that is triggered as a reaction to some negative stimulus. Fear can be a mild caution or an extreme phobia.'
                },
                {
                    toneId: 'joy',
                    emoji: '🥳',
                    emojiText: 'Joy',
                    details: 'Joy (or happiness) has shades of enjoyment, satisfaction, and pleasure. Joy brings a sense of well-being, inner peace, love, safety, and contentment.'
                },
                {
                    toneId: 'sadness',
                    emoji: '😥',
                    emojiText: 'Sadness',
                    details: 'Sadness indicates a feeling of loss and disadvantage. When a person is quiet, less energetic, and withdrawn, it can be inferred that they feel sadness.'
                },
                {
                    toneId: 'sad',
                    emoji: '😥',
                    emojiText: 'Sad',
                    details: 'Sad indicates a feeling of loss and disadvantage. When a person is quiet, less energetic, and withdrawn, it can be inferred that they feel sad.'
                },
                {
                    toneId: 'analytical',
                    emoji: '🤔',
                    emojiText: 'Analytical',
                    details: "An analytical tone indicates a person's reasoning and analytical attitude about things. An analytical person might be perceived as intellectual, rational, systematic, emotionless, or impersonal."
                },
                {
                    toneId: 'confident',
                    emoji: '🤝',
                    emojiText: 'Confident',
                    details: "A confident tone indicates a person's degree of certainty. A confident person might be perceived as assured, collected, hopeful, or egotistical."
                },
                {
                    toneId: 'tentative',
                    emoji: '😅',
                    emojiText: 'Tentative',
                    details: "A tentative tone indicates a person's degree of inhibition. A tentative person might be perceived as questionable, doubtful, or debatable."
                },
                {
                    toneId: 'frustrated',
                    emoji: '😤',
                    emojiText: 'Frustrated',
                    details: 'A frustrated tone is defined as feeling annoyed and irritable.'
                },
                {
                    toneId: 'satisfied',
                    emoji: '😆',
                    emojiText: 'Satisfied',
                    details: 'A satisfied tone is an affective response to perceived service quality'
                },
                {
                    toneId: 'excited',
                    emoji: '🤩',
                    emojiText: 'Excited',
                    details: 'An excited tone indicates that the person is showing personal enthusiasm and interest.'
                },
                {
                    toneId: 'polite',
                    emoji: '😇',
                    emojiText: 'Polite',
                    details: 'This tone uses courteous language and maintains professional boundaries, fostering an atmosphere of decorum and respect.'
                },
                {
                    toneId: 'impolite',
                    emoji: '👿',
                    emojiText: 'Impolite',
                    details: 'An impolite tone indicates a person being disrespectful and rude'
                },
                {
                    toneId: 'sympathetic',
                    emoji:'❤️',
                    emojiText: 'Sympathetic',
                    details: 'A sympathetic tone is an affective mode of understanding that involves emotional resonance'
                },
                {
                    toneId: 'disheartening',
                    emoji:'💔',
                    emojiText: 'Disheartening',
                    details: 'A disheartening tone indicates a feeling of discouragement, disappointment, and sadness.'
                },
                {
                    toneId: 'accusatory',
                    emoji:'👎',
                    emojiText: 'Accusatory',
                    details: 'An accusatory tone indicates that a person is blaming someone else for a mistake or wrongdoing.'
                },
                {
                    toneId: 'disapproving',
                    emoji:'😖',
                    emojiText: 'Disapproving',
                    details: 'A disapproving tone suggests that the person does not approve of the situation or action being discussed.'
                },
                {
                    toneId: 'appreciative',
                    emoji:'🌟',
                    emojiText: 'Appreciative',
                    details: 'This tone expresses gratitude for efforts and accomplishments, encouraging further positive behavior and boosting morale.'
                },
        
                {
                    toneId: 'unassuming',
                    emoji:'🙄',
                    emojiText: 'Unassuming',
                    details: 'An unassuming tone is one that is modest, humble, and not boastful or assertive.'
                },
                {
                    toneId: 'concerned',
                    emoji:'😟',
                    emojiText: 'Concerned',
                    details: `A concerned tone indicates that the person is worried, anxious, and showing care for the listener's well-being.`
                },
                {
                    toneId: 'egocentric',
                    emoji:'🧐',
                    emojiText: 'Egocentric',
                    details: 'An egocentric tone indicates that the person is self-centered, thinking only about themselves.'
                },
                {
                    toneId: 'optimistic',
                    emoji:'✌️',
                    emojiText: 'Optimistic',
                    details: 'An optimistic tone suggests that the person is hopeful and positive about the future.'
                },
                {
                    toneId: 'joyful',
                    emoji:'🙂',
                    emojiText: 'Joyful',
                    details: 'A joyful tone indicates that the person is happy, elated, and expressing pleasure.'
                },
                {
                    toneId: 'curious',
                    emoji:'🤔',
                    emojiText: 'Curious',
                    details: 'A curious tone suggests that the person is inquisitive and eager to learn more about something.'
                },
                {
                    toneId: 'formal',
                    emoji:'🤵',
                    emojiText: 'Formal',
                    details: 'A formal tone implies a serious, professional, and conventional style of communication.'
                },

                {
                    toneId: 'friendly',
                    emoji:'😊',
                    emojiText: 'Friendly',
                    details: 'This tone indicates warmth, openness, and willingness to engage. It helps in fostering a positive and welcoming environment.'
                },

                {
                    toneId: 'respectful',
                    emoji:'🙏',
                    emojiText: 'Respectful',
                    details: 'This tone demonstrates consideration and esteem for others, their thoughts, and their feelings. It supports the dignity of others and creates an atmosphere of mutual respect.'
                },
                {
                    toneId: 'encouraging',
                    emoji:'💪',
                    emojiText: 'Encouraging',
                    details: " This tone shows support, motivation, and confidence in others' abilities. It inspires individuals to face challenges and continue their progress."
                },
                {
                    toneId: 'empathetic',
                    emoji:'💙',
                    emojiText: 'Empathetic',
                    details: 'This tone expresses understanding and shared feelings with others, conveying that their emotional experiences are valued and respected.'
                },
                {
                    toneId: 'patient',
                    emoji:'⏳',
                    emojiText: 'Patient',
                    details: 'This tone indicates an understanding that everyone has their own pace for comprehension and response. It fosters a non-pressured environment conducive to learning and growth.'
                },
                {
                    toneId: 'collaborative',
                    emoji:'🤝',
                    emojiText: 'Collaborative',
                    details: 'This tone suggests teamwork and mutual contribution towards shared goals. It helps in fostering a sense of unity and common purpose.'
                },
                {
                    toneId: 'open-minded',
                    emoji:'🌈',
                    emojiText: 'Open-minded',
                    details: 'This tone signifies a willingness to consider new and diverse ideas. It encourages creativity and innovation.'
                },
                {
                    toneId: 'constructive',
                    emoji:'🔨',
                    emojiText: 'Constructive',
                    details: 'This tone offers feedback aimed at improvement and growth. It helps people recognize their strengths and address their weaknesses.'
                },
           
                {
                    toneId: 'aggressive',
                    emoji:'😠',
                    emojiText: 'Aggressive',
                    details: 'This tone conveys hostility and can make others feel intimidated or threatened. It can create a negative and fear-based environment.'
                },
                {
                    toneId: 'condescending',
                    emoji:'😏',
                    emojiText: 'Condescending',
                    details: "This tone implies a feeling of superiority, often belittling or disregarding others' thoughts and feelings. It can cause discomfort and discourage open communication."
                },
                {
                    toneId: 'passive-aggressive',
                    emoji:'😒',
                    emojiText: 'Passive-aggressive',
                    details: 'This tone indirectly expresses negative feelings or resentment, creating an unclear and unhealthy communication environment.'
                },
                {
                    toneId: 'impatient',
                    emoji:'⌛',
                    emojiText: 'Impatient',
                    details: 'This tone communicates frustration when others need more time or help. It can make others feel rushed or stressed.'
                },
                {
                    toneId: 'dismissive',
                    emoji:'🙄',
                    emojiText: 'Dismissive',
                    details: "This tone undermines or ignores others' ideas, feelings, or concerns. It can lead to a feeling of being undervalued."
                },
                {
                    toneId: 'sarcastic',
                    emoji:'😜',
                    emojiText: 'Sarcastic',
                    details: 'This tone uses irony or mockery, which can lead to misunderstanding or hurt feelings.'
                },
                {
                    toneId: 'defensive',
                    emoji:'🛡️',
                    emojiText: 'Defensive',
                    details: 'This tone resists criticism or feedback, often responding with hostility. It hinders growth and discourages open and honest feedback.'
                },
                {
                    toneId: 'rude',
                    emoji:'🤬',
                    emojiText: 'Rude',
                    details: 'This tone includes offensive language, gestures, or behaviors. It can lead to a hostile and disrespectful environment.'
                },
                {
                    toneId: 'gossiping',
                    emoji:'🤐',
                    emojiText: 'Gossiping',
                    details: 'This tone involves spreading rumors or discussing private information without consent, leading to trust issues and a toxic environment.'
                },
                {
                    toneId: 'overly critical',
                    emoji:'😞',
                    emojiText: 'Overly critical',
                    details: 'This tone focuses excessively on flaws and mistakes without offering constructive feedback or encouragement, which can decrease morale and confidence.'
                },


            ]
            let count_value=0
            const arr=new Array()
            const arrAgo=new Array()

            await firebase.firestore().collection('toneanalyze').where('company', '==', user.company).where('date', '>=', fourteenago).get()
            .then((querySnapshot) =>  {
                querySnapshot.forEach(function (doc) {
                    const data = doc.data();

                if(format(new Date(data.date),"YYYY-MM-DD")>=sevenago){
                   
                    if(data.toneAnalyse && data.toneAnalyse !== 0 && data.toneAnalyse.length > 0 ){
                        // console.log("tone_id",data)
                        let tone_id=''
                        
                        if(data.toneAnalyse[0].score){
                         
                            tone_id=data.toneAnalyse[0].tone_id.toLowerCase()
                            

                        }else{
                            tone_id=data.toneAnalyse[0].messageTone.toLowerCase()
       
                        }
                        
                            switch(tone_id) {
                                case 'anger': sumTone.anger++
                                break;
                                case 'fear': sumTone.fear++
                                break;
                                case 'joy': sumTone.joy++
                                break;
                                case 'sadness': sumTone.sadness++
                                break;
                                case 'analytical': sumTone.analytical++
                                break;
                                case 'confident': sumTone.confident++
                                break;
                                case 'tentative': sumTone.tentative++
                                break;
                                case 'frustrated': sumTone.frustrated++
                                break;
                                case 'satisfied': sumTone.satisfied++
                                break;
                                case 'excited': sumTone.excited++
                                break;
                                case 'polite': sumTone.polite++
                                break;
                                case 'impolite': sumTone.impolite++
                                break;
                                case 'sympathetic':sumTone.sympathetic++
                                break;
                                case 'disheartening':sumTone.disheartening++
                                break;
                                case 'sad':sumTone.sad++
                                break;
                                case 'accusatory':sumTone.accusatory++
                                break;
                                case 'disapproving':sumTone.disapproving++
                                break;
                                case 'appreciative':sumTone.appreciative++
                                break;
                                case 'encouraging':sumTone.encouraging++
                                break;
                                case 'unassuming':sumTone.unassuming++
                                break;
                                case 'concerned':sumTone.concerned++
                                break;
                                case 'egocentric':sumTone.egocentric++
                                break;
                                case 'optimistic':sumTone.optimistic++
                                break;
                                case 'joyful':sumTone.joyful++
                                break;
                                case 'curious':sumTone.curious++
                                break;
                                case 'formal':sumTone.formal++
                                break;
                                case 'friendly':sumTone.friendly++
                                break;
                                case 'respectful':sumTone.respectful++
                                break;
                                case 'empathetic':sumTone.empathetic++
                                break;
                                case 'patient':sumTone.patient++
                                break;
                                case 'collaborative':sumTone.collaborative++
                                break;
                                case 'open-minded':sumTone.open_minded++
                                break;
                                case 'open_minded':sumTone.open_minded++
                                break;
                                case 'constructive':sumTone.constructive++
                                break;
                                case 'aggressive':sumTone.aggressive++
                                break;
                                case 'condescending':sumTone.condescending++
                                break;
                                case 'passive-aggressive':sumTone.passive_aggressive++
                                break;
                                case 'passive_aggressive':sumTone.passive_aggressive++
                                break;
                                case 'impatient':sumTone.impatient++
                                break;
                                case 'dismissive':sumTone.dismissive++
                                break;
                                case 'sarcastic':sumTone.sarcastic++
                                break;
                                case 'defensive':sumTone.defensive++
                                break;
                                case 'rude':sumTone.rude++
                                break;
                                case 'gossiping':sumTone.gossiping++
                                break;
                                case 'overly critical':sumTone.overly_critical++
                                break;

                            }

                            sumTone.sum++    
                            
                    }
                }else{
                    
                    if(data.toneAnalyse && data.toneAnalyse !== 0 && data.toneAnalyse.length > 0 ){
                            let tone_id=''
                            
                            if(data.toneAnalyse[0].score){
                                tone_id=data.toneAnalyse[0].tone_id.toLowerCase()
                            }else{
                                tone_id=data.toneAnalyse[0].messageTone.toLowerCase()
                            }
                            
                            switch (tone_id) {
                                case 'anger': sumToneAgo.anger++
                                    break;
                                case 'fear': sumToneAgo.fear ++
                                    break;
                                case 'joy': sumToneAgo.joy ++
                                    break;
                                case 'sadness': sumToneAgo.sadness++
                                    break;
                                case 'analytical': sumToneAgo.analytical++
                                    break;
                                case 'confident': sumToneAgo.confident++
                                    break;
                                case 'tentative': sumToneAgo.tentative ++
                                    break;
                                case 'frustrated': sumToneAgo.frustrated ++
                                    break;
                                case 'satisfied': sumToneAgo.satisfied ++
                                    break;
                                case 'excited': sumToneAgo.excited ++
                                    break;
                                case 'polite': sumToneAgo.polite++
                                    break;
                                case 'impolite': sumToneAgo.impolite ++
                                    break;
                                case 'sympathetic': sumToneAgo.sympathetic ++
                                    break;
                                case 'disheartening':sumToneAgo.disheartening++
                                    break;
                                case 'sad':sumToneAgo.sad++
                                    break;
                                case 'accusatory':sumToneAgo.accusatory++
                                    break;
                                case 'disapproving':sumToneAgo.disapproving++
                                    break;
                                case 'appreciative':sumToneAgo.appreciative++
                                    break;
                                case 'encouraging':sumToneAgo.encouraging++
                                    break;
                                case 'unassuming':sumToneAgo.unassuming++
                                    break;
                                case 'concerned':sumToneAgo.concerned++
                                    break;
                                case 'egocentric':sumToneAgo.egocentric++
                                    break;
                                case 'optimistic':sumToneAgo.optimistic++
                                    break;
                                case 'joyful':sumToneAgo.joyful++
                                    break;
                                case 'curious':sumToneAgo.curious++
                                    break;
                                case 'formal':sumToneAgo.formal++
                                    break;
                                case 'friendly':sumToneAgo.friendly++
                                    break;
                                case 'respectful':sumToneAgo.respectful++
                                    break;
                                case 'empathetic':sumToneAgo.empathetic++
                                    break;
                                case 'patient':sumToneAgo.patient++
                                    break;
                                case 'collaborative':sumToneAgo.collaborative++
                                    break;
                                case 'open-minded':sumToneAgo.open_minded++
                                    break;
                                case 'open_minded':sumToneAgo.open_minded++
                                    break;
                                case 'constructive':sumToneAgo.constructive++
                                    break;
                                case 'aggressive':sumToneAgo.aggressive++
                                    break;
                                case 'condescending':sumToneAgo.condescending++
                                    break;
                                case 'passive-aggressive':sumToneAgo.passive_aggressive++
                                    break;
                                case 'passive_aggressive':sumToneAgo.passive_aggressive++
                                    break;
                                case 'impatient':sumToneAgo.impatient++
                                    break;
                                case 'dismissive':sumToneAgo.dismissive++
                                    break;
                                case 'sarcastic':sumToneAgo.sarcastic++
                                    break;
                                case 'defensive':sumToneAgo.defensive++
                                    break;
                                case 'rude':sumToneAgo.rude++
                                    break;
                                case 'gossiping':sumToneAgo.gossiping++
                                    break;
                                case 'overly critical':sumToneAgo.overly_critical++
                                    break;
                            }
                            sumToneAgo.sum ++
                    }

                }

                })
                
            })
 
            for (const [key, value] of Object.entries(sumTone)) {
                const percent = Math.round((((value / sumTone.sum) * 100) * 1e12) / 1e12).toFixed(0)
                const tone=key.replace("_", "-").toLowerCase();
                arr.push({ percentage: value === 0 ? 0 : Number(percent), toneId: tone })
            }
           
            for (const [key, value] of Object.entries(sumToneAgo)) {
                const percent = Math.round((((value / sumToneAgo.sum) * 100) * 1e12) / 1e12).toFixed(0)
                const tone=key.replace("_", "-").toLowerCase();
                arrAgo.push({ percentageAgo: value === 0 ? 0 : Number(percent), toneId: tone })
            }

            const tone = _.orderBy(arr, 'percentage', 'desc')
            const _tone = tone.map((value, i) => {
                return { ...value, rankingNow: i }
            })
            
            const toneAgo = _.orderBy(arrAgo, 'percentageAgo', 'desc')
            const _toneAgo = toneAgo.map((value, i) => { return { ...value, rankYesterdayDay: value.percentageAgo == 0 ? 0 : i } })

            var merge_tone = _.map(_tone, function (item) {
                return _.merge(item, _.find(_toneAgo, { 'toneId': item.toneId }));
            });
           
            const data_tone = merge_tone.map((value) => {
                if (value.percentage !== 0) {
                    count_value++
                }
                return { ...value, percentageChange: value.percentage - value.percentageAgo }
            })
            
            var toneAnalyse = _.map(data_tone, function (item) {
                return _.merge(item, _.find(_emoji, { 'toneId': item.toneId }));
            });
       
            commit('setToneLoadingStatus', false);
            commit('setToneAnalyse', toneAnalyse.slice(1, count_value <= 5 ? count_value : 6))
  
        },
        async getPast12Hours({commit,state, dispatch}:any,user:any){
            var dashboard:Array<any>=[]
            await firebase.database().ref(`dashboard_realtime/${user.company}`).on('child_added', (snapshot, prevChildKey) => {               
                const hours =format(snapshot.val().createdate,'hh a')
                const h =format(snapshot.val().createdate,'hh-a')
                const _hours =format(snapshot.val().createdate,'YYYY-MM-DD hh a')
                dashboard.push({...snapshot.val(),hours:hours,sort:_hours})
                dispatch('setPast12Hour',{...snapshot.val(),hours:hours,sort:_hours,key:snapshot.key,_type:"add",h:h})
              
              });
            firebase.database().ref(`dashboard_realtime/${user.company}`).on('child_removed', (snapshot) => {
                dispatch('setPast12Hour',{...snapshot.val(),key:snapshot.key,_type:"delete"})
               
              });
            
        },
        async setPast12Hour({commit,state}:any,doc:any){
            let Past12Hours:Array<any>=[]
            var Past:Array<any>=[]
            var Active12Hours:Array<any>=[]
            var count=0
            var countSession=0
            var arrData:Array<any>=[]
            var time:Array<any>=[]
            let master= [
            {type:"session-lead-attendees",text:"Learning Interactions"},
            {type:"booster",text:"Running Track Boosters"},
            {type:"peerfeedback",text:"Peer Feedback"},
            {type:"redeem_reward",text:"Reward Redeemed"},
            {type:"sent_gift",text:"Gift Sent"},
            {type:"open-ended-feedback",text:"Conversations Initiated"},
            {type:"manager_replies",text:"Manager Replies"},
            {type:"mission-entries",text:"Mission Entries"},
            {type:"townhall",text:"Discussions"},
            {type:"recognition",text:"Peer Recognition"},
            {type:"behavioral-nudge",text:"Behavioral Nudge"},]

            //var Active12Hours={}
            if(doc._type=="delete"){
                let option=_.filter(
                    state._temp,
                    function (currentObject) {
                        return currentObject.key!=doc.key
                    })
               // console.log("option",option)
                state._temp=option

            }else{
                state._temp.push(doc)
            }
            var groupBy_hours= _.groupBy(state._temp, 'hours')
            for(let i=1;i<13;i++){
                const hours =format(subHours(new Date(),i),'hh a')
                const add_hours =format(subHours(new Date(),(i+1)),'hh a')
                var text=""
                var count_time=0
                var sort=""
                const check_add_hours=add_hours.split(" ")
                const check_time=hours.split(" ")
                if(check_add_hours[1]==check_time[1]){
                    text=check_add_hours[0]+"-"+check_time[0]+" "+check_time[1]
                }else {
                    text=add_hours+" - "+ hours
                }
                    for(var _value in groupBy_hours[hours])
                    {
                        if(groupBy_hours[hours][_value].type!="session-lead-attendees"){
                            count_time++
                        }else{
                            count_time=count_time+groupBy_hours[hours][_value].count
                        }
                        sort=groupBy_hours[hours][0].sort
                    }
                //console.log("groupBy_hours[hour]",groupBy_hours[hours])
                Active12Hours.push({time:text,active:count_time,sort:sort})
                
            }
           
                
            // for (var value in groupBy_hours){
            //         var count_time=0
            //         var sort=""
            //         var text=""
            //         for(var i in groupBy_hours[value])
            //         {
            //             if(groupBy_hours[value][i].type!="session-lead-attendees"){
            //                 count_time++
            //             }else{
            //                 count_time=count_time+groupBy_hours[value][i].count
            //             }
            //             sort=groupBy_hours[value][0].sort
            //         }
            //         const add_hours =format(addHours(groupBy_hours[value][0].createdate,1),'hh a')
            //         const check_add_hours=add_hours.split(" ")
            //         const check_time=value.split(" ")
            //         if(check_add_hours[1]==check_time[1]){
            //             text=check_time[0]+"-"+check_add_hours[0]+" "+check_time[1]
            //         }else {
            //             text=value+" - "+add_hours
            //         }
            //         //Active12Hours.push({time:text,active:count_time,sort:sort,hours:groupBy_hours[value][0].hours})
            //         Active12Hours[value]={time:text,active:count_time,sort:sort,hours:groupBy_hours[value][0].hours}
            //     }
        
                var myArray = _.sortBy(Active12Hours, function(dateObj) {
                    return new Date(dateObj.sort);
                  });
                myArray.map(value=>{
                    time.push(value.time)
                    arrData.push(value.active)
                }) 
                  commit('setactiveRecord',{time:time,data:arrData})






        var groupBy_dashboard = _.groupBy(state._temp, 'type')
                
                for (var value in groupBy_dashboard){
                    
                    
                    let text:any = _.find(master, (item): any => {
                        return item.type==value
                        });
// console.log("text",text)
                    if(value!="session-lead-attendees"){

                        count=count+groupBy_dashboard[value].length
                       Past12Hours.push({label:(text&&text.text)?text.text:"",value:groupBy_dashboard[value].length})
                    }else{
                        for (var data in groupBy_dashboard["session-lead-attendees"]){
                            count=count+groupBy_dashboard["session-lead-attendees"][data].count
                            countSession=countSession+groupBy_dashboard["session-lead-attendees"][data].count
                        }
                        Past12Hours.push({label:(text&&text.text)?text.text:"",value:countSession})
                    }
                   
                }
 
                var result= _.orderBy(Past12Hours, 'value', 'desc')
                if(result.length<4){
                    commit('setpast12Hour',result)
                }else {
                    Past.push(result[0],result[1],result[2],result[3])
                    commit('setpast12Hour',Past)
                }
                commit('setMaximumUsers',count)
 
        },
        async getManager({commit,state,rootState}:any,doc:any){
            if(!state.teamHeight){
                let teamHeight:any
                let topmostArr: Array<any> = [];
                const teams = (await firebase.database().ref('team').orderByChild("company").equalTo(`${rootState.authen.user.company}`).once('value')).val()
                for(const x in teams){
                    if(!teams[x].parent){
                        topmostArr.push(x)
                    }
                }
                teamHeight = topmostArr[0]
                if(topmostArr.length > 1){
                    teamHeight = _.find(topmostArr, (value) => {
                    const chk_topmost = _.find(teams, { parent: value });
                    return !!chk_topmost;
                    });
                }
                commit('setTeamHeight',teamHeight)
            }
            let teamOneLevel: any = [];
            await firebase.firestore().collection('organization1level').doc(`${rootState.authen.user.company}-${state.teamHeight}`).get()
            .then(function (doc) {
                teamOneLevel = doc.data()
            });
            state.teamOneLevel=teamOneLevel
            const data2:Array<any> = []
            let subTeam:any = {}
            subTeam[state.teamHeight] = true
            const users=(await firebase.database().ref(`users`).orderByChild("company").equalTo(`${rootState.authen.user.company}`).once('value')).val()
            let organization1level = (teamOneLevel && teamOneLevel.parent && teamOneLevel.parent) ? teamOneLevel.parent : subTeam
            const manager_classification = (await firebase.database().ref(`company/${rootState.authen.user.company}/manager_classification`).once('value')).val()
            let act_open_rate = manager_classification ? manager_classification.active_open_rate : state.insightsOpenRateSetting.active
            let act_feedback_rate = manager_classification ? manager_classification.active_feedback_rate : state.feedbackReplyRateSetting.active
            let pass_open_rate = manager_classification ? manager_classification.passive_open_rate : state.insightsOpenRateSetting.passive
            let pass_feedback_rate = manager_classification ? manager_classification.passive_feedback_rate : state.feedbackReplyRateSetting.passive
            let countAll = 0
            let countAct = 0
            let countPas = 0
            let countInact = 0
            await firebase.firestore().collection('insight_manager_today').where('company', '==', rootState.authen.user.company).where("date", ">=", format(addDays(new Date(), -30), 'YYYY-MM-DD')).orderBy('date').get().then((querySnapshot) => {
                querySnapshot.forEach((doc) => {
                    const data = doc.data()
                    const emailKey=data.email.replace(/\./g, '||')
                    //placeholder is true check topmost fixed 2 boss in topmost 
                    if(users[emailKey]&&!users[emailKey].placeholder){
                        if(organization1level[data.team]){
                            if (data2[data.email] === undefined) {
                                data2[data.email] = {}
                            }
                            data2[data.email].team = doc.data().team;
                            // sometime data error read > receive
                            if(data.read > data.receive){
                                data.read = data.receive
                            }
                            if(doc.data().type=="feedback"){
                                if(data2[data.email].read_feedback === undefined) data2[data.email].read_feedback = 0
                                if(data2[data.email].receive_feedback === undefined) data2[data.email].receive_feedback = 0
                                data2[data.email].read_feedback += data.read
                                data2[data.email].receive_feedback += data.receive
                            }else if(doc.data().type=="report_daily_boss"){
                                if(data2[data.email].read_report_daily_boss === undefined) data2[data.email].read_report_daily_boss = 0
                                if(data2[data.email].receive_report_daily_boss === undefined) data2[data.email].receive_report_daily_boss = 0
                                data2[data.email].read_report_daily_boss += data.read
                                data2[data.email].receive_report_daily_boss += data.receive
                            }else if(doc.data().type=="report_weekly_boss"){
                                if(data2[data.email].read_report_weekly_boss === undefined) data2[data.email].read_report_weekly_boss = 0
                                if(data2[data.email].receive_report_weekly_boss === undefined) data2[data.email].receive_report_weekly_boss = 0
                                data2[data.email].read_report_weekly_boss += data.read
                                data2[data.email].receive_report_weekly_boss += data.receive
                            }
                        }
                    }
                });
                for(const email in data2){
                    let report_daily_boss=0
                    let feedback=0
                    let report_weekly_boss=0
                    let _feedback=''
                    if(data2[email]){
                        if(data2[email].receive_feedback>0){
                            feedback = (data2[email].read_feedback/data2[email].receive_feedback)*100
                        }else{
                            feedback = 100
                            data2[email].feedback = 100
                            _feedback='-'
                        }
                        if(data2[email].receive_report_weekly_boss>0) report_weekly_boss = (data2[email].read_report_weekly_boss/data2[email].receive_report_weekly_boss)*100;
                        if(data2[email].receive_report_daily_boss>0)  report_daily_boss = (data2[email].read_report_daily_boss/data2[email].receive_report_daily_boss)*100;
                        if(report_daily_boss > 100 ) report_daily_boss = 100;
                        if(report_weekly_boss > 100 ) report_weekly_boss = 100;
                        if(feedback > 100 ) feedback = 100;
                        let dailyData = report_daily_boss? Math.round(report_daily_boss) : 0 
                        let weeklyData = report_weekly_boss?Math.round(report_weekly_boss) : 0;
                        let open_rate = ((dailyData * 5 + weeklyData))/6
                        data2[email].open_rate = open_rate
                        if(open_rate >= act_open_rate && Math.round(feedback) >= act_feedback_rate){
                            if(_feedback == '-'&&act_open_rate==0&&pass_open_rate==0){
                                countPas += 1
                              }else{
                                countAct += 1
                              }
                       
                        }else if(open_rate >= pass_open_rate && Math.round(feedback) >= pass_feedback_rate){
                            countPas += 1
                        }else{
                            countInact += 1
                        }
                        countAll += 1
                        data2[email].daily = (report_daily_boss) ? Math.round(report_daily_boss) : 0
                        data2[email].weekly = (report_weekly_boss) ? Math.round(report_weekly_boss) : 0
                        data2[email].feedback = (feedback) ? Math.round(feedback) : 0
                    }
                }
                commit('setManagerData',{all:countAll,active:countAct,passive:countPas,inactive:countInact})
            });
        },
        closePast12Hours({commit,state}:any,user:any){
            commit('setactiveRecord',[])
            commit('setpast12Hour',[])
            commit('setMaximumUsers',0)
            state.count=0
            state._temp=[]
            firebase.database().ref(`dashboard_realtime/${user.company}`).off();

        },
        async getQuestionOpenEnd({commit,state}:any,user:any){
            let question:any={}
            const company= (await firebase.database().ref(`/company/${user.company}`).once('value')).val()
             const _question= (await firebase.database().ref(`/questions/${company.lastopenend.question_id}`).once('value')).val()
             if((company.lastopenend.question_id!='-L1u2Xa5_pSCnitgF3u6' && company.lastopenend.question_id!= '-L1u2Xa5_pSCnitgF3u65' && company.lastopenend.question_id!='-L1u93FCwY42UOoIhXPC' && _question.status == 'Y') || (_question.parent == 'Y' && _question.status == 'N')){
                question = _question
                question.key = company.lastopenend.question_id
                question.question_id=company.lastopenend.question_id
                if(_question.type == 'Multiple Choice'){
                    if(_question.m_choice.en.length==2)
                    {
                        if(_question.m_choice.en[0].toUpperCase()==="YES"&&_question.m_choice.en[1].toUpperCase()==="NO")
                        {
                            question.type_name = 'Yes/No'
                        }
                        else if(_question.m_choice.en[1].toUpperCase()==="YES"&&_question.m_choice.en[0].toUpperCase()==="NO")
                        {
                            question.type_name = 'Yes/No'
                        }
                        else{
                            question.type_name = 'Multiple Choice'
                            question.custom_type="multiple_choice"}
                    }else{
                        question.type_name = 'Multiple Choice'
                        question.custom_type="multiple_choice"
                    }

                }else if(_question.type == 'Text Area Field'){
                    question.type_name = 'Open-ended'
                }else{
                    question.type_name = _question.type
                }
                if(_question.repeats=="onetime"){
                    question.frequency="One-time"
                }else if(_question.repeats=="weekly"){
                    let frequencyDay=0
                    _.forEach(_question.repeat_days, (value)=> {
                        if(value==="Y")
                         {frequencyDay++}
                    });
                    
                    if (frequencyDay >= 5) {
                        question.frequency="Daily"
                      } else {
                        question.frequency="Weekly"
                      }
                    
                }else if(_question.repeats=="monthly"){
                    if (_question.repeat_every > 1) {
                        question.frequency="Bi-monthly"
                    }
                    else{
                        question.frequency="Monthly"
                    }
                    
                    
                }else if(_question.repeats=="quarterly"){
                    if (_question.repeat_quarters) {
                        if(_question.repeat_quarters.Q1=="Y"&&_question.repeat_quarters.Q2=="Y"&&_question.repeat_quarters.Q3=="Y"&&_question.repeat_quarters.Q4=="Y"){
                            question.frequency="Quarterly"
                        }else{
                            question.frequency="Bi-annually"
                        }
                    }
                    
                }
                else {
                    question.frequency="Yearly"
                  
                }
                commit('setQuestionOpenEnd',question)
                // console.log("finsh",question)
                //questions.push(question)
            }
            // commit('setQuestionOpenEnd',{question_en:question.question_en,question_id:company.lastopenend.question_id})
            //.where("quest_id",'not-in',["-Lww4xIIHQ5hmxEhR2nE"])
            // firebase.firestore().collection('users_questions').where("company", "==", user.company).where("quest_id",'not-in',["-Lww4xIIHQ5hmxEhR2nE"]).where("type","==","Text Area Field").orderBy('date', 'desc').limit(1).get()
            // .then(function (querySnapshot) {
            //     console.log("u",querySnapshot.docs[0].data())
                
            //     })
        
            // firebase.firestore().collection('users_questions').where("company", "==", user.company).where("type","==","Text Area Field").orderBy('date', 'desc').limit(1).get()
            // .then(function (querySnapshot) {
            //             question={
            //                 question_en:querySnapshot.docs[0].data().quest_name_en,
            //                 date:querySnapshot.docs[0].data().date,
            //                 question_id:querySnapshot.docs[0].data().quest_id
            //             }
            //             commit('setQuestionOpenEnd',question)
            //     })
        },
        async getImpactRating({commit,state,rootState}:any,user:any){
        commit('setImpactRatingloading',true)
        var data={green:0,yellow:0,red:0,all:0}
        let arrData:Array<any>=[]
        for(const x in user){
            const u = user[x]
            data.all++
            if(u.impact_rating){
                if(u.impact_rating>=70){
                    data.green++
                }else if(u.impact_rating>=40&&u.impact_rating<70){
                    data.yellow++
                }else if(u.impact_rating<40){
                    data.red++
                }
            }
        }
            if(data.all>50){
                let dot=data.all/50
                var active=(data.green/dot).toFixed()
                let passive=(data.yellow/dot).toFixed()
                for(var i=0;i<50;i++){
                  if(i<parseInt(active)){
                    arrData.push('green')
                  }else if(i<(parseInt(active)+parseInt(passive))){
                    arrData.push('yellow')
                  }else{
                    arrData.push('red')
                  }
                   
                }
            }else{
                  for(var i=0;i<50;i++){
                    if(i<data.green){
                        arrData.push('green')
                    }else if(i<(data.green+data.yellow)){
                        arrData.push('yellow')
                    }else if(i<(data.green+data.yellow+data.red)){
                        arrData.push('red')
                    }else {
                        arrData.push('gray')
                    }
                }
          
            }
           
            commit('setEngagementpeople',{arr:arrData, highImpact:data.green})
            commit('setImpactRatingloading',false)
      
        //  firebase.database().ref('users').orderByChild('company').equalTo(`${rootState.authen.user.company}`).once('value', snapshot => {
        //         snapshot.forEach((arrData): any => {

        },
        async getEnps({commit,state,rootState}:any,_data:any){
        commit('setEnpsloading', true)
        const company = (await firebase.database().ref(`/company/${rootState.authen.user.company}`).once('value')).val()
        let teamHeight:any
        let dataRecent:Array<any>=[]
        let data:Array<any>=[]
        let type:any=''
        let value:any={}
        let totalUser:any=0
        let total:any =0
        // await firebase.database().ref('team').orderByChild('company').equalTo(`${rootState.authen.user.company}`).once('value', snapshot => {
        //     snapshot.forEach((doc): any => {
        //     if (!doc.val().parent){
        //         teamHeight = doc.key
        //     } 
        //     });
        // });
        let topmostArr: Array<any> = [];
        for(const x in _data.teams){
            if(!_data.teams[x].parent){
                topmostArr.push(x)
            }
        }
        teamHeight = topmostArr[0]
        if(topmostArr.length > 1){
            teamHeight = _.find(topmostArr, (value) => {
            const chk_topmost = _.find(_data.teams, { parent: value });
            return !!chk_topmost;
            });
        }
        if(company.lastreportcard){
            if(company.lastreportcard.reportcard_type=="eNPS"||company.lastreportcard.reportcard_type=="NPS"){
                if(company.lastreportcard.reportcard_type=="eNPS"){
                    type="-L1QT78ajNkp6MpsLkBu"
                }else 
                {
                    type="-M4F5P10foOhqehfK3lv"
                }
            
                //eps,enps
                await firebase.firestore().collection('insight_teams_report_card_fix').where("company", "==", rootState.authen.user.company).where("quest_id","==",type).where("team","==",teamHeight).get()
                    .then(function (querySnapshot) {
                        querySnapshot.forEach(function (doc) {
                                const _data = doc.data()
                                _data.type=company.lastreportcard.reportcard_type
                                dataRecent.push(_data)
                            })
                            dataRecent.map(value=>{
                                if(value && value.answer && Object.keys(value.answer).length > 0){
                                    let promotors:any = 0
                                    let detractors:any = 0
                                    let passives:any = 0
                                    let enps_score:any = 0
                                    let percent:any={promotors:0,detractors:0,passives:0}
                                    let allScores:any = []
                                    _.forEach(value.answer, function (count, key:number) {
                                        if(key >= 0 && key <= 6){
                                            detractors+= count
                                        }else if(key >=9 && key <= 10){
                                            promotors+= count
                                        }else {
                                            passives+=count
                                        }
                                        // Store all scores with their counts
                                        allScores.push({score: key, count: count})
                                    });
                                    enps_score = ((promotors / Number(value.total)) - (detractors / Number(value.total)))*100
                                    let total:any = globalfunc.round(enps_score,0)
                                    percent.promotors=(promotors*100/value.total).toFixed()||"-"
                                    percent.passives=(passives*100/value.total).toFixed()||"-"
                                    percent.detractors=(detractors*100/value.total).toFixed()||"-"
                                    data.push({
                                        total:total||"-",
                                        detractors:detractors||"-",
                                        promotors:promotors||"-",
                                        passives:passives||"-",
                                        percent:percent,
                                        date:value.date,
                                        type:value.type,
                                        allScores: allScores
                                    })
                                }
                                
                            })
                            if(data.length==0){
                                let percent={
                                    excellent:"-",
                                    fair:"-",
                                    critical:"-"
                                }
                                commit("setEnps",{total:"-",excellent:"-",fair:"-",critical:"-",percent:percent,date:"-",type:"-"})
                                commit("setBenchmarkBreak","-")
                                commit('setEnpsloading', false)
                            }else{
                                commit("setEnps",data[0])
                                commit("setBenchmarkBreak",data.length>0?data[0].type:'-')
                                commit('setEnpsloading', false)

                            }
                            
                   
                })
    
            }else{  
                let questionSet:Array<any>=[]
                if(company.lastreportcard.reportcard_type=="WHO-5"){
                    questionSet=['-MdMv_XgThL0o2iunlhE','-MdMw8kfpZtxnppGUA1f','-MdMyavdF-YvuyzW6cA5','-MdMz-TodEXbj3AC68oP','-MdMzwfySVTjhOAGoxTP'] // WHO-5
                }else if(company.lastreportcard.reportcard_type=="eRes") 
                {
                    questionSet=['-MgaSDDhL-3mt78QHuYL','-MgaSw_L3eW0WyF4ZplB','-MgaTQObIM08enQK5p3F','-MgaU6mpwzOgerV7w-IW','-MgaUfGLnzhU0BcUv5Db']
                }else {
                    questionSet=['-MjPYFeALtFMAJkTEiFn','-MjPZ15ImFhkjDiMI3gH','-MjPZVq3sRBZJwtr7_Tx','-MjP_2__thuvnVc_RY0k','-MjP_R_bWBdQvFhf5BTY']
                }
                   await firebase.firestore().collection('insight_teams_report_card_fix').where("company", "==",rootState.authen.user.company).where("quest_id","in",questionSet).where("team","==",teamHeight).get()
                    .then(function (querySnapshot) {
                        querySnapshot.forEach(function (doc) {
                                const _data = doc.data()
                                dataRecent.push(_data)
              
                            })
                            let dataSum=0
                            let maxmimum=0
                            let allScores:any = []
                            let totalUser = 0
                            dataRecent.map(value=>{
                                for(let y=0; y<6; y++){
                                    if(value.answer[y]){
                                        dataSum += (value.answer[y]) * (5 - y)
                                        maxmimum += value.answer[y] * 5
                                        // Store individual question scores
                                        allScores.push({
                                            questionId: value.quest_id,
                                            score: y,
                                            count: value.answer[y],
                                            weightedScore: (value.answer[y]) * (5 - y)
                                        })
                                    }
                                }
                            })
                            
                            total = (((dataSum * 100) / maxmimum).toFixed())
                            
                            // Calculate percentages for excellent, fair, and critical users
                            let percent = {
                                excellent: isNaN((((value && value.excellentUsers && value.excellentUsers.length || 0) * 100) / totalUser)) ? '-' : ((((value && value.excellentUsers && value.excellentUsers.length || 0) * 100) / totalUser).toFixed()),
                                fair: isNaN((((value && value.fairUsers && value.fairUsers.length || 0) * 100) / totalUser)) ? "-" : ((((value && value.fairUsers && value.fairUsers.length || 0) * 100) / totalUser).toFixed()),
                                critical: isNaN((((value && value.criticalUsers && value.criticalUsers.length || 0) * 100) / totalUser)) ? "-" : ((((value && value.criticalUsers && value.criticalUsers.length || 0) * 100) / totalUser).toFixed())
                            }
                            
                            data.push({
                                total: parseInt(total)||"-",
                                excellent: (value && value.excellentUsers && value.excellentUsers.length) || "-",
                                fair: (value && value.fairUsers && value.fairUsers.length) || "-",
                                critical: (value && value.criticalUsers && value.criticalUsers.length) || "-",
                                percent: percent,
                                date: (value && value.date) || "-",
                                type: company.lastreportcard.reportcard_type || "-",
                                allScores: allScores
                            })
                    
                    commit("setEnps",data[0])
                    commit("setBenchmarkBreak",data[0].type)
                    commit('setEnpsloading', false) 

                        
                })
    
            }
        }else{
            let percent={
                excellent:"-",
                fair:"-",
                critical:"-"
            }
            commit("setEnps",{total:"-",excellent:"-",fair:"-",critical:"-",percent:percent,date:"-",type:"-"})
            commit("setBenchmarkBreak","-")
            commit('setEnpsloading', false) 
            
        }
        

 




                // await firebase.firestore().collection('insight_teams_report_card_fix').where("company", "==", user.company).where("quest_id","in",questionSet1).where("team","==",teamHeight).get()
                // .then(function (querySnapshot) {
                //     querySnapshot.forEach(function (doc) {
                //             const _data = doc.data()
                //             who5.push(_data)
                //         })
                //         let dataSum=0
                //         let maxmimum=0
                //         let excellent=0
                //         let fair=0
                //         let critical=0
                //         let sumActive=0
                //         let date:any=''
                //         who5.map(value=>{
                //             sumActive+=value.total
                //             for(let y=0; y<6; y++){
                //                 if(value.answer[y]){
                //                     dataSum += (value.answer[y]) * (5 - y)
                //                     maxmimum += value.answer[y] * 5
                //                     let score=(((value.answer[y] * (5 - y) )* 100) /( value.answer[y] * 5))
                //                     if(score>=80){
                //                         excellent+=value.answer[y]
                //                     }else if( 50 <= score &&score < 80){
                //                         fair+=value.answer[y]
                //                     }else {
                //                         critical+=value.answer[y]
                //                     }
                //                 }
                //             }
                //         })
                //         let percent={
                //             excellent:(((excellent * 100) / sumActive).toFixed()),
                //             fair:(((fair * 100) / sumActive).toFixed()),
                //             critical:(((critical * 100) / sumActive).toFixed())
                //         }
                //         let total:any = (((dataSum * 100) / maxmimum).toFixed())
                //         data.push({total:parseInt(total)||"-",excellent:excellent||"-",fair:fair||"-",critical:critical||"-",percent:percent,date:date,type:'WHO-5 Wellbeing Index'})
                //     })    

                //     await firebase.firestore().collection('insight_teams_report_card_fix').where("company", "==", user.company).where("quest_id","in",questionSet2).where("team","==",teamHeight).get()
                // .then(function (querySnapshot) {
                //     querySnapshot.forEach(function (doc) {
                //             const _data = doc.data()
                //             who5.push(_data)
                //         })
                //         let dataSum=0
                //         let maxmimum=0
                //         let excellent=0
                //         let fair=0
                //         let critical=0
                //         let sumActive=0
                //         let date:any=''
                //         who5.map(value=>{
                //             sumActive+=value.total
                //             for(let y=0; y<6; y++){
                //                 if(value.answer[y]){
                //                     dataSum += (value.answer[y]) * (5 - y)
                //                     maxmimum += value.answer[y] * 5
                //                     let score=(((value.answer[y] * (5 - y) )* 100) /( value.answer[y] * 5))
                //                     if(score>=80){
                //                         excellent+=value.answer[y]
                //                     }else if( 50 <= score &&score < 80){
                //                         fair+=value.answer[y]
                //                     }else {
                //                         critical+=value.answer[y]
                //                     }
                //                 }
                //             }
                //         })
                //         let percent={
                //             excellent:(((excellent * 100) / sumActive).toFixed()),
                //             fair:(((fair * 100) / sumActive).toFixed()),
                //             critical:(((critical * 100) / sumActive).toFixed())
                //         }
                //         let total:any = (((dataSum * 100) / maxmimum).toFixed())
                //         data.push({total:parseInt(total)||"-",excellent:excellent||"-",fair:fair||"-",critical:critical||"-",percent:percent,date:date,type:'Employee Resilience Index'})
                //     })  

                //     await firebase.firestore().collection('insight_teams_report_card_fix').where("company", "==", user.company).where("quest_id","in",questionSet3).where("team","==",teamHeight).get()
                // .then(function (querySnapshot) {
                //     querySnapshot.forEach(function (doc) {
                //             const _data = doc.data()
                //             who5.push(_data)
                //         })
                //         let dataSum=0
                //         let maxmimum=0
                //         let excellent=0
                //         let fair=0
                //         let critical=0
                //         let sumActive=0
                //         let date:any=''
                //         who5.map(value=>{
                //             sumActive+=value.total
                //             for(let y=0; y<6; y++){
                //                 if(value.answer[y]){
                //                     dataSum += (value.answer[y]) * (5 - y)
                //                     maxmimum += value.answer[y] * 5
                //                     let score=(((value.answer[y] * (5 - y) )* 100) /( value.answer[y] * 5))
                //                     if(score>=80){
                //                         excellent+=value.answer[y]
                //                     }else if( 50 <= score &&score < 80){
                //                         fair+=value.answer[y]
                //                     }else {
                //                         critical+=value.answer[y]
                //                     }
                //                 }
                //             }
                //         })
                //         let percent={
                //             excellent:(((excellent * 100) / sumActive).toFixed()),
                //             fair:(((fair * 100) / sumActive).toFixed()),
                //             critical:(((critical * 100) / sumActive).toFixed())
                //         }
                //         let total:any = (((dataSum * 100) / maxmimum).toFixed())
                //         data.push({total:parseInt(total)||"-",excellent:excellent||"-",fair:fair||"-",critical:critical||"-",percent:percent,date:date,type:'Culture Index'})
                //     })  

                    
                    

        },

        async getMemberAndTeam({commit,state,rootState,dispatch}:any,user:any){
          
            var users={}
            if(Object.keys(rootState.main.allUser).length>0){
                 users= rootState.main.allUser
            }else{
                 users= await dispatch("main/getuser",'',{root:true})
            }
           //console.log("users",users)
            //var users= (await firebase.database().ref('users').orderByChild("company").equalTo(`${rootState.authen.user.company}`).once('value')).val()
            const teams = (await firebase.database().ref('team').orderByChild("company").equalTo(`${rootState.authen.user.company}`).once('value')).val()
            commit('setMemberAndTeam',{users:users,teams:teams})
            const _teamHight=_.groupBy(users,'boss')
            state.totol_boss=Object.keys(_teamHight).length-1
            if(!_teamHight||!_teamHight[""][0]||!_teamHight[""][0]['team']) return null
                state.teamHight=_teamHight[""][0]['team']||null
            return {users:users,teams:teams}

        },
        
        async getAdoption({commit,state, dispatch,rootState}:any,user:any){
            commit('setActivityLoadingStatus',true)
            // var users=user
            let countAdoption=0
            let totalUsers=0
            // firebase.database().ref().child('users').orderByChild('company').equalTo(`${rootState.authen.user.company}`).once('value', snapshot => {
            //     snapshot.forEach((doc):any => {
                for(let x in user){
                    totalUsers++
                if(user[x].tutorial=="Y"){
                    countAdoption++
                    }
                }
                //const user = doc.val()
                
                // })
                let adoption=(countAdoption*100/totalUsers).toFixed(2)
                state.countAdoption=countAdoption
                commit("setAdoption",parseFloat(adoption).toFixed())//{adoption:parseFloat(adoption), benchmark:(parseFloat(adoption)-90).toFixed(2)})
                dispatch("getMonthly")
                dispatch("getWeekly") 
            // })

        },

        async getMonthly({commit,state, dispatch,rootState}:any,user:any){
            commit('setActivityLoadingStatus',true)
            let currentData:any={}
            let currentDate=format(new Date(),'YYYY-MM') 
            let percent_change:any=0
            let subDate=format(subMonths(new Date(),1),'YYYY-MM') 
            await firebase.firestore().collection("active_users").doc(`${rootState.authen.user.company}-${currentDate}`)
            .onSnapshot({
            }, (doc) => {
                currentData=doc.data()
                firebase.firestore().collection("active_users").doc(`${rootState.authen.user.company}-${subDate}`)
                .onSnapshot({
                }, (doc1) => {
                let data=doc1.data()
                let bar=(currentData.active_users*100)/state.countAdoption
                if(data){
                     percent_change=((currentData.active_users-parseInt(data.active_users))/data.active_users)*100
        
                     if(percent_change<0){
                        percent_change=(percent_change*-1).toFixed()
                        percent_change=(percent_change*-1)
                    }else{
                        percent_change=parseFloat(percent_change).toFixed()
                    }
                    
                }

              
                commit('setMonthly',{activeCurrent:currentData.active_users,bar:bar,percent_change:percent_change})
 
            });
                
            });
        },
        async getWeekly({commit,state, dispatch,rootState}:any,user:any){
            commit('setActivityLoadingStatus',true)
            let currentData:any={}
            let currentDate=format(new Date(),'YYYY-W') 
            let percent_change:any=0
            let subDate=format(subWeeks(new Date(),1),'YYYY-W') 
            await firebase.firestore().collection("active_users_weekofyear").doc(`${rootState.authen.user.company}-${currentDate}`)
            .onSnapshot({
            }, (doc) => {
                currentData=doc.data()
                firebase.firestore().collection("active_users_weekofyear").doc(`${rootState.authen.user.company}-${subDate}`)
                .onSnapshot({
                }, (doc1) => {
                let data=doc1.data()
                let bar=(currentData.active_users*100)/state.countAdoption
                if(data){
                    percent_change=(((currentData.active_users-parseInt(data.active_users))/data.active_users)*100)
                    if(percent_change<0){
                        percent_change=(percent_change*-1).toFixed()
                        percent_change=(percent_change*-1)
                    }else{
                        percent_change=parseFloat(percent_change).toFixed()
                    }
               }
               
                commit('setWeekly',{activeCurrent:currentData.active_users,bar:bar,percent_change:percent_change})
                //console.log("doc1",doc1.data())
                commit('setActivityLoadingStatus',false)
                
            });
                
            });
            

            
        },
        
        async getComEncryp({commit,state}:any,user:any){
            const userData:any = localStorage.getItem('userData')
            let DecrypUserData = JSON.parse(decodeURIComponent(atob(userData)))
            DecrypUserData.company = '---TEST---'
            let EncrypUserData = btoa(encodeURIComponent(JSON.stringify(DecrypUserData)))
            //console.log("EncrypUserData",EncrypUserData)
        }

        },
    getters: {
        activeuser: (state: any) => {
            return state.activeuser
        },
        dimension: (state: any) => {
            return state.dimension
        },
        happiness: (state: any) => {
            return state.happiness
        },
        feedback: (state: any) => {
            return state.feedback
        },
        dateshow: (state: any) => {
            return state.dateshow
        },
        questions: (state: any) => {
            return state.questions
        },
        questions_name: (state: any) => {
            return state.questions_name
        },
        talking_points_daily: (state: any) => {
            return state.talking_points_daily
        },
        talking_points_monthly: (state: any) => {
            return state.talking_points_monthly
        },
        talking_points_30d: (state: any) => {
            return state.talking_points_30d
        },
        datachart: (state: any) => {
            return state.datachart
        },
        databarchart: (state: any) => {
            return state.databarchart
        },
        databarchartEngagementScore: (state: any) => {
            return state.databarchartEngagementScore
        },
        datakeygroup: (state: any) => {
            return state.datakeygroup
        },
        opt_month_name: (state: any) => {
            return state.opt_month_name
        },
        newLabels: (state: any) => {
            return state.newLabels
        },
        toneAnalyse:(state: any) => {
            return state.toneAnalyse
        },
        toneloadingStatus:(state: any) => {
            return state.toneLoadingStatus
        },
        datachartloadingStatus:(state: any) => {
            return state.databarchartLoadingStatus
        },
        EngagementScoreLoadingStatus:(state: any) => {
            return state.EngagementScoreLoadingStatus
        },
        datakeygrouploadingStatus:(state: any) => {
            return state.datakeygroupLoadingStatus
        },
        maximumUsers:(state: any) => {
            return state.maximumUsers
        },
        past12Hour:(state: any) => {
            return state.past12Hour
        },
        activeRecord:(state: any) => {
            return state.activeRecord
        },
        questionOpenEnd:(state: any) => {
            return state.questionOpenEnd
        },
        engagementpeople:(state: any) => {
            return state.engagementpeople
        },
        enps:(state: any) => {
            return state.enps
        },
        adoption:(state: any) => {
            return state.adoption
        },
        monthlyActiveUser:(state: any)=>{
            return state.monthlyActiveUser
        },
        weeklyActiveUser:(state: any)=>{
            return state.weeklyActiveUser
        },
        enpsLoading:(state: any)=>{
            return state.enpsLoading
        },
        happinessLoading:(state: any)=>{
            return state.happinessLoading
        },
        impactRatingLoading:(state: any)=>{
            return state.impactRatingLoading
        },
        feedbackLoading:(state: any)=>{
            return state.feedbackLoading
        },
        activityLoadingStatus:(state: any)=>{
            return state.activityLoadingStatus
        },
        openModalDashboard:(state: any)=>{
            return state.openModalDashboard
        },
        benchmarkBreak:(state: any)=>{
            return state.benchmarkBreak
        },
        managerData:(state: any)=>{
            return state.managerData
        },
    }
}